import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.find.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { action, computed, makeObservable, observable, reaction, runInAction } from "mobx";
import Base from "./Base";
import DPServices from "@dp/services";
import MobileAccordionModel from "./models/MobileAccordionModel";
import BreadSticksModel from "./models/BreadSticksModel";
import CheckModel from "./models/CheckModel";
import EmailReceiptModel from "./models/EmailReceiptModel";
import { ERRORS, handle, Logger, getEnvProps, PlatformType, formatPhoneNumber, getLocalISODateString } from "@dp/common";
import { OnlinePaymentTypes, PaymentMethods, PaymentFlow, MPAnalyticsPaymentMethod, DialogueCodes, getDialogueCode, MobilePayLoadCheckFailure, MobilePayPaymentFailure, MobilePayCouponErrors } from "../utils";
import i18next from "i18next";
import Errors, { ERROR_STRINGS } from "./Errors";
import moment from "moment-timezone";
export var Route;

(function (Route) {
  Route[Route["CHECK"] = 0] = "CHECK";
  Route[Route["CODE"] = 1] = "CODE";
  Route[Route["CONFIRMATION"] = 2] = "CONFIRMATION";
  Route[Route["SITE_APP_ONLY"] = 3] = "SITE_APP_ONLY";
  Route[Route["LOCATION_APP_ONLY"] = 4] = "LOCATION_APP_ONLY";
  Route[Route["SITE_MOBILE_PAY_UNAVAIALABLE"] = 5] = "SITE_MOBILE_PAY_UNAVAIALABLE";
  Route[Route["LOCATION_MOBILE_PAY_UNAVAIALABLE"] = 6] = "LOCATION_MOBILE_PAY_UNAVAIALABLE";
  Route[Route["CHECK_CLOSED"] = 7] = "CHECK_CLOSED";
  Route[Route["CHECK_UPDATED"] = 8] = "CHECK_UPDATED";
  Route[Route["GENERAL_FAILURE"] = 9] = "GENERAL_FAILURE";
  Route[Route["PAYMENT_FAILURE"] = 10] = "PAYMENT_FAILURE";
  Route[Route["SITE_WEB_ONLY"] = 11] = "SITE_WEB_ONLY";
  Route[Route["LOCATION_WEB_ONLY"] = 12] = "LOCATION_WEB_ONLY";
  Route[Route["CALL_IN_FLOW_ERROR"] = 13] = "CALL_IN_FLOW_ERROR";
  Route[Route["VIEW_CHECK"] = 14] = "VIEW_CHECK";
  Route[Route["NO_CHECK_FOUND"] = 15] = "NO_CHECK_FOUND";
  Route[Route["CHECK_ERROR"] = 16] = "CHECK_ERROR";
  Route[Route["CHECKOUT_LOADING"] = 17] = "CHECKOUT_LOADING";
  Route[Route["DIGITAL_CHECK_LOADING"] = 18] = "DIGITAL_CHECK_LOADING";
  Route[Route["LARGE_PARTY_CHECKS_FOUND"] = 19] = "LARGE_PARTY_CHECKS_FOUND";
})(Route || (Route = {}));

var UNABLE_TO_FIND_CHECK = "Check not found or Invalid payment code.";
var MobilePay = (_class = /*#__PURE__*/function (_Base) {
  _inherits(MobilePay, _Base);

  var _super = _createSuper(MobilePay); // Add all models for mobile pay here.


  function MobilePay(rootStore) {
    var _this$rootStore$user;

    var _this;

    _classCallCheck(this, MobilePay);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "formState", _descriptor, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _defineProperty(_assertThisInitialized(_this), "payment", null);

    _defineProperty(_assertThisInitialized(_this), "accordionModel", null);

    _defineProperty(_assertThisInitialized(_this), "checkModel", null);

    _defineProperty(_assertThisInitialized(_this), "breadSticksModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "emailReceiptModel", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "_couponCodeWidgetEnabled", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_route", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "appAttributes", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "mobilePayAppAttributes", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "restaurantDetails", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_shownInitialCheckForMPAY", _descriptor7, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "receivedError", false);

    _initializerDefineProperty(_assertThisInitialized(_this), "_showExitMobilePayDialogue", _descriptor8, _assertThisInitialized(_this));

    _this.rootStore = rootStore;
    _this.appMessages = rootStore.appMessages;
    _this.payment = rootStore.payment;
    _this.accordionModel = new MobileAccordionModel(_this.rootStore.platformUtil);
    _this.checkModel = new CheckModel();
    _this.breadSticksModel = new BreadSticksModel();
    _this.emailReceiptModel = new EmailReceiptModel(_this.rootStore.platformUtil);
    _this.formState = {
      submitCount: 0,
      apiFiredCount: 0,
      isFailed: false,
      isSubmitting: false,
      isSuccess: false
    };
    _this.analyticsModel = (_this$rootStore$user = _this.rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : _this$rootStore$user.analyticsModel;
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MobilePay, [{
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this; //app-init


      reaction(function () {
        return {
          appAttributes: _this2.rootStore.common.appAttributes
        };
      }, function (data) {
        _this2.processAppAttributes(data.appAttributes);
      });
      reaction(function () {
        return {
          submitCount: _this2.formState.submitCount
        };
      }, function (data) {
        var isSubmitted = data.submitCount > 0;
        _this2.payment.formSubmitted = isSubmitted;
      });
      reaction(function () {
        return {
          isLoggedIn: _this2.rootStore.user.isLoggedIn,
          userProfile: _this2.rootStore.user.userProfile
        };
      }, function (data) {
        if (data.isLoggedIn) {
          _this2._processUserProfile(data.isLoggedIn, data.userProfile);
        }
      });
      reaction(function () {
        var _this2$checkModel, _this2$checkModel$ord;

        return {
          restNumber: (_this2$checkModel = _this2.checkModel) === null || _this2$checkModel === void 0 ? void 0 : (_this2$checkModel$ord = _this2$checkModel.order) === null || _this2$checkModel$ord === void 0 ? void 0 : _this2$checkModel$ord.restNumber
        };
      }, function (data) {
        if (data.restNumber) {
          _this2._getRestaurantDetails(data.restNumber.toString());
        }
      });
    }
  }, {
    key: "_getRestaurantDetails",
    value: function () {
      var _getRestaurantDetails2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(restaurantNumber) {
        var _this3 = this;

        var restaurantDetails;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return DPServices.Restaurant.getRestaurantDetailsByNumber(restaurantNumber);

              case 3:
                restaurantDetails = _context.sent;
                runInAction(function () {
                  _this3.restaurantDetails = restaurantDetails;
                });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                throw new Error("Error loading location details.");

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      function _getRestaurantDetails(_x) {
        return _getRestaurantDetails2.apply(this, arguments);
      }

      return _getRestaurantDetails;
    }()
  }, {
    key: "_processUserProfile",
    value: function _processUserProfile(isLoggedIn, userProfile) {
      //Will be invoked after login happens
      if (isLoggedIn && userProfile) {
        var canUseMobilePay = this.rootStore.user.isMobilePayAvailable;
        var paymentCode = this.checkModel.paymentCode;
        var paymentCodeValid = this.checkModel.isValid;
        this.emailReceiptModel.setUserData(userProfile.login);

        if (canUseMobilePay) {
          if (paymentCode && paymentCodeValid) {
            this.loadCheck(true);
          }
        } else {
          // Mobile Pay Unavailable
          this.checkModel.dialogueCode = DialogueCodes.CHARGE_BACK_GUEST;
          this.route = Route.SITE_MOBILE_PAY_UNAVAIALABLE;
        }
      }
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$rootStore$user2, isLoggedIn, userProfile;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.payment.flow = PaymentFlow.MPAY_CLQ;
                _this$rootStore$user2 = this.rootStore.user, isLoggedIn = _this$rootStore$user2.isLoggedIn, userProfile = _this$rootStore$user2.userProfile;
                this.processAppAttributes(this.rootStore.common.appAttributes);

                if (isLoggedIn) {
                  this.emailReceiptModel.setUserData(userProfile.login);
                }

              // Debugging Purposes
              //this.rootStore.common.appAttributes.isWebMobilePayLoginEnforced = true;
              //this.rootStore.common.appAttributes.isAppMobilePayEnabled = true;
              //this.rootStore.common.appAttributes.isWebMobilePayEnabled = false;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "processAppAttributes",
    value: function processAppAttributes(appAttributes) {
      var _appAttributes$config, _appAttributes$config2, _appAttributes$config3;

      this.appAttributes = appAttributes;
      var isPaypalMobilePayEnabled = appAttributes === null || appAttributes === void 0 ? void 0 : (_appAttributes$config = appAttributes.configs) === null || _appAttributes$config === void 0 ? void 0 : _appAttributes$config.isPaypalMobilePayEnabled;
      var isApplePayMobilePayEnabled = appAttributes === null || appAttributes === void 0 ? void 0 : (_appAttributes$config2 = appAttributes.configs) === null || _appAttributes$config2 === void 0 ? void 0 : _appAttributes$config2.isApplePayMobilePayEnabled;
      var isGooglePayMobilePayEnabled = appAttributes === null || appAttributes === void 0 ? void 0 : (_appAttributes$config3 = appAttributes.configs) === null || _appAttributes$config3 === void 0 ? void 0 : _appAttributes$config3.isGooglePayMobilePayEnabled;
      this.breadSticksModel.setAppAttributesData(appAttributes);

      if (this.payment) {
        this.payment.requestPhoneNumberFromAppleOrGooglePay = false;
        this.payment.requestShippingFieldsFromAppleOrGooglePay = false;
        this.payment.isPayPalEnabled = isPaypalMobilePayEnabled === "true";
        this.payment.isApplePayEnabled = isApplePayMobilePayEnabled === "true";
        this.payment.isGooglePayEnabled = isGooglePayMobilePayEnabled === "true";
        this.payment.creditCardInfo.fullAVSEnabled = false;
      }
    }
  }, {
    key: "processCheckResponse",
    value: function processCheckResponse(order) {
      if (order) {
        var _order$order$tippable;

        this.checkModel.order = order;
        var isCheckLockedForFraudSuspicion = order === null || order === void 0 ? void 0 : order.isCheckLockedForFraudSuspicion;

        if (isCheckLockedForFraudSuspicion) {
          // Disabled Credit Card Payment
          this.checkModel.dialogueCode = DialogueCodes.FRAUD_SUSPICION_LOCK;
          this.payment.isCCPaymentDisabled = true;
        }

        var tax = order.order.taxAmount.value;
        var subTotal = order.order.subTotal.value;
        this.payment.tippableAmount = (_order$order$tippable = order.order.tippableAmount) === null || _order$order$tippable === void 0 ? void 0 : _order$order$tippable.value;
        var preAppliedCouponCode = order.couponCode;
        var preAppliedCouponDiscount = order.couponDiscount;
        var stackedCoupons = order.stackedCoupons;
        var preAppliedPayments = this.checkModel.preAppliedPayments;
        this.payment.orderPriceInfo = {
          rawSubTotal: subTotal,
          tax: tax,
          discountAmount: preAppliedCouponDiscount,
          amountAlreadyPaid: preAppliedPayments.cumulativeAmount,
          gratuityAlreadyPaid: preAppliedPayments.cumulativeTip
        };
        this.payment.couponModel.couponCode = null;

        if (preAppliedCouponDiscount) {
          var appliedCouponCode = preAppliedCouponCode === null || preAppliedCouponCode === void 0 ? void 0 : preAppliedCouponCode.toUpperCase();
          this.payment.couponModel.appliedCouponCode = appliedCouponCode;
          this.payment.couponModel.couponDiscount = preAppliedCouponDiscount;
          this.payment.couponModel.showCouponCode = false;
          this.couponCodeWidgetEnabled = true;
        } else {
          this.couponCodeWidgetEnabled = preAppliedPayments.cumulativeAmount <= 0;
          this.payment.couponModel.appliedCouponCode = null;
          this.payment.couponModel.couponDiscount = null;
        }

        this.payment.couponModel.canRemoveCoupon = !stackedCoupons && (this.payment.flow === PaymentFlow.MPAY_OPCIO ? !!preAppliedCouponCode : true);
      }
    }
  }, {
    key: "checkForMobilePayAvailability",
    value: function checkForMobilePayAvailability(isWebMobilePayEnabled, isAppMobilePayEnabled) {
      var primaryMobilePay = {};
      var secondaryMobilePay = {};

      if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
        primaryMobilePay.isAvailable = isWebMobilePayEnabled;
        primaryMobilePay.isWeb = true;
        secondaryMobilePay.isAvailable = isAppMobilePayEnabled;
        secondaryMobilePay.isWeb = false;
      } else {
        primaryMobilePay.isAvailable = isAppMobilePayEnabled;
        primaryMobilePay.isWeb = false;
        secondaryMobilePay.isAvailable = isWebMobilePayEnabled;
        secondaryMobilePay.isWeb = true;
      }

      return {
        primaryMobilePay: primaryMobilePay,
        secondaryMobilePay: secondaryMobilePay
      };
    }
  }, {
    key: "setPaymentFlow",
    value: function setPaymentFlow(paymentCode) {
      if (!!paymentCode) {
        var paymentCodeLength = paymentCode.length;

        if (paymentCodeLength < 37) {
          if (paymentCodeLength < 17) {
            this.payment.flow = PaymentFlow.MPAY_CLQ;
          } else {
            this.payment.flow = PaymentFlow.MPAY_TLQ;
          }
        } else {
          this.payment.flow = PaymentFlow.MPAY_OPCIO;
        }
      }
    }
  }, {
    key: "loadCheck",
    value: function () {
      var _loadCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var checkNavigationDisabled,
            paymentCode,
            _order$mobilePayEnabl,
            _order$order,
            _order$order2,
            _order$order2$balance,
            JWT_TOKEN,
            order,
            isSavedSettlementInformation,
            isWebMobilePayEnabled,
            isAppMobilePayEnabled,
            customMaxGratuityValue,
            balance,
            _this$checkForMobileP,
            primaryMobilePay,
            secondaryMobilePay,
            _this$checkModel$orde,
            _this$payment$orderPr,
            _this$payment$orderPr2,
            _order$order3,
            _this$checkModel$orde2,
            _this$checkModel$orde3,
            _loadCheckError$messa,
            _this$checkModel$orde4,
            _analyticsError$error,
            analyticsError,
            loadCheckError,
            _this$checkModel$call,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                checkNavigationDisabled = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
                paymentCode = this.checkModel.paymentCode; // const samplechecks = await import("../mockdata/samplechecks.json");
                // const mockOrder =
                //   paymentCode && samplechecks ? samplechecks[paymentCode] : null;

                this.setPaymentFlow(paymentCode);

                if (this.canLoadCheck) {
                  _context3.next = 7;
                  break;
                }

                this.checkModel.dialogueCode = DialogueCodes.PAYMENT_CODE_REGEX_VALIDATION;
                this.checkModel.errorMessage = "Invalid Payment code.";
                return _context3.abrupt("return");

              case 7:
                if (this.payment.flow === PaymentFlow.MPAY_CLQ || checkNavigationDisabled) {
                  this.route = Route.CHECKOUT_LOADING;
                } else {
                  this.route = Route.DIGITAL_CHECK_LOADING;
                }
                /*if (mockOrder) {
                  const balance = mockOrder?.successResponse?.order?.balance?.value;
                   if (balance <= 0) {
                    addUrlParam("paymentCode", paymentCode);
                    this.processCheckResponse(mockOrder);
                    this.route = Route.CONFIRMATION;
                  } else {
                    const isWebMobilePayEnabled =
                      mockOrder.successResponse.isWebMobilePayEnabled === null ||
                      mockOrder.successResponse.isWebMobilePayEnabled === undefined
                        ? true
                        : mockOrder.successResponse.isWebMobilePayEnabled;
                    const isAppMobilePayEnabled =
                      mockOrder.successResponse.isAppMobilePayEnabled === null ||
                      mockOrder.successResponse.isAppMobilePayEnabled === undefined
                        ? true
                        : mockOrder.successResponse.isAppMobilePayEnabled;
                     if (isWebMobilePayEnabled) {
                      addUrlParam("paymentCode", paymentCode);
                      this.processCheckResponse(mockOrder);
                      this.route = Route.CHECK;
                    } else {
                      if (isAppMobilePayEnabled) {
                        this.route = Route.LOCATION_APP_ONLY;
                      } else {
                        this.route = Route.LOCATION_MOBILE_PAY_UNAVAIALABLE;
                      }
                    }
                  }
                  dispatchAnalyticsEvent("MobilePay", {
                    paymentCode: paymentCode,
                  });
                } else {*/


                _context3.prev = 8;
                _context3.next = 11;
                return this.getDefaultTipPercentage();

              case 11:
                _context3.next = 13;
                return this.rootStore.user.getTokenSilentIfLoggedIn();

              case 13:
                JWT_TOKEN = _context3.sent;
                _context3.next = 16;
                return DPServices.Check.getCheckDetails(JWT_TOKEN, {
                  paymentCode: paymentCode
                });

              case 16:
                order = _context3.sent;

                if (!(this.payment.flow === PaymentFlow.MPAY_TLQ && !((_order$mobilePayEnabl = order.mobilePayEnable) !== null && _order$mobilePayEnabl !== void 0 && _order$mobilePayEnabl.tableMobilePayEnable))) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 20;
                return this.reset();

              case 20:
                return _context3.abrupt("return");

              case 21:
                isSavedSettlementInformation = this.checkForSavedSettlementInformation((_order$order = order.order) === null || _order$order === void 0 ? void 0 : _order$order.paymentItems);

                if (!(this.payment.flow === PaymentFlow.MPAY_OPCIO && isSavedSettlementInformation)) {
                  _context3.next = 27;
                  break;
                }

                this.route = Route.CALL_IN_FLOW_ERROR;
                this.checkModel.dialogueCode = DialogueCodes.CHECK_ALREADY_PAID;
                this.checkModel.callInError = {
                  title: "",
                  message: "Check has already been paid!",
                  icon: "CHECK"
                };
                return _context3.abrupt("return");

              case 27:
                isWebMobilePayEnabled = order.isWebMobilePayEnabled === null || order.isWebMobilePayEnabled === undefined ? true : order.isWebMobilePayEnabled;
                isAppMobilePayEnabled = order.isAppMobilePayEnabled === null || order.isAppMobilePayEnabled === undefined ? true : order.isAppMobilePayEnabled;
                customMaxGratuityValue = Number(order.customMaxGratuityValue) || 999;
                this.payment.gratuityModel.customMaxGratuityValue = customMaxGratuityValue;
                balance = (_order$order2 = order.order) === null || _order$order2 === void 0 ? void 0 : (_order$order2$balance = _order$order2.balance) === null || _order$order2$balance === void 0 ? void 0 : _order$order2$balance.value;

                if (balance <= 0) {
                  this.checkModel.dialogueCode = DialogueCodes.CHECK_CLOSED;
                  this.route = Route.CHECK_CLOSED;
                } else {
                  _this$checkForMobileP = this.checkForMobilePayAvailability(isWebMobilePayEnabled, isAppMobilePayEnabled), primaryMobilePay = _this$checkForMobileP.primaryMobilePay, secondaryMobilePay = _this$checkForMobileP.secondaryMobilePay;

                  if (primaryMobilePay.isAvailable) {
                    this.determinePaymentMethods(order);
                    this.processCheckResponse(order);

                    if (primaryMobilePay.isWeb) {
                      this.rootStore.platformUtil.addUrlParam("paymentCode", paymentCode);
                    }

                    if (!checkNavigationDisabled && (this.payment.flow === PaymentFlow.MPAY_OPCIO || this.payment.flow === PaymentFlow.MPAY_TLQ)) {
                      if (order !== null && order !== void 0 && (_order$order3 = order.order) !== null && _order$order3 !== void 0 && _order$order3.packagingItems) {
                        this.breadSticksModel.checkDetailItems = order.order.packagingItems;
                      }

                      this.route = Route.VIEW_CHECK;
                    } else {
                      this.shownInitialCheckForMPAY = true;
                      this.route = Route.CHECK;
                    }

                    this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "MobilePay", {
                      paymentCode: paymentCode,
                      success: true,
                      restNum: (_this$checkModel$orde = this.checkModel.order) === null || _this$checkModel$orde === void 0 ? void 0 : _this$checkModel$orde.restNumber,
                      paymentType: this.payment.activeOtherOptionTab,
                      total: this.payment.orderTotalIncludingGratuity,
                      tip: this.payment.gratuity,
                      tax: (_this$payment$orderPr = this.payment.orderPriceInfo) === null || _this$payment$orderPr === void 0 ? void 0 : _this$payment$orderPr.tax,
                      discount: (_this$payment$orderPr2 = this.payment.orderPriceInfo) === null || _this$payment$orderPr2 === void 0 ? void 0 : _this$payment$orderPr2.discountAmount
                    });
                  } else {
                    if (secondaryMobilePay.isAvailable) {
                      if (secondaryMobilePay.isWeb) {
                        this.route = Route.LOCATION_WEB_ONLY;
                      } else {
                        this.route = Route.LOCATION_APP_ONLY;
                      }

                      this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "MobilePay", {
                        paymentCode: paymentCode,
                        success: false,
                        restNum: (_this$checkModel$orde2 = this.checkModel.order) === null || _this$checkModel$orde2 === void 0 ? void 0 : _this$checkModel$orde2.restNumber,
                        message: "Mobile Pay available on ".concat(secondaryMobilePay.isWeb ? "Web" : "App", " only.")
                      });
                    } else {
                      this.route = Route.LOCATION_MOBILE_PAY_UNAVAIALABLE;
                      this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "MobilePay", {
                        paymentCode: paymentCode,
                        success: false,
                        restNum: (_this$checkModel$orde3 = this.checkModel.order) === null || _this$checkModel$orde3 === void 0 ? void 0 : _this$checkModel$orde3.restNumber,
                        message: "Mobile Pay unavailable."
                      });
                    }
                  }
                }

                _context3.next = 105;
                break;

              case 35:
                _context3.prev = 35;
                _context3.t0 = _context3["catch"](8);
                analyticsError = {};
                loadCheckError = DPServices.Common.handleUIErrorAndOverride(_context3.t0, {
                  title: "",
                  message: ""
                });
                analyticsError.errorCode = loadCheckError.errorCode;
                analyticsError.errorDescription = null; // updating value to null so can use "??"

                loadCheckError.message = (_loadCheckError$messa = loadCheckError.message) !== null && _loadCheckError$messa !== void 0 && _loadCheckError$messa.length ? loadCheckError.message : null;

                if (!loadCheckError.errorCode) {
                  _context3.next = 99;
                  break;
                }

                _context3.t1 = loadCheckError.errorCode;
                _context3.next = _context3.t1 === MobilePayLoadCheckFailure.TLQ_NOT_ENABLED_ERROR ? 46 : _context3.t1 === MobilePayLoadCheckFailure.ERROR_PAYMENT_CODE_NOT_FOUND ? 50 : _context3.t1 === MobilePayLoadCheckFailure.ERROR_CHECK_NOT_FOUND ? 53 : _context3.t1 === MobilePayLoadCheckFailure.checkNotFound ? 53 : _context3.t1 === MobilePayLoadCheckFailure.ERROR_AVAILABLE_ON_APP ? 56 : _context3.t1 === MobilePayLoadCheckFailure.ERROR_AVAILABLE_ON_WEB ? 59 : _context3.t1 === MobilePayLoadCheckFailure.ERROR_CHECK_SATISFIED ? 62 : _context3.t1 === MobilePayLoadCheckFailure.checkSatisfiedError ? 65 : _context3.t1 === MobilePayLoadCheckFailure.ERROR_CHECK_CLOSED ? 68 : _context3.t1 === MobilePayLoadCheckFailure.checkClosed ? 71 : _context3.t1 === MobilePayLoadCheckFailure.ERROR_MOBILE_PAY_NOT_AVAILABLE ? 74 : _context3.t1 === MobilePayLoadCheckFailure.ERROR_CHECK_TOTAL_THRESHOLD ? 77 : _context3.t1 === MobilePayLoadCheckFailure.connectivityError ? 80 : _context3.t1 === MobilePayLoadCheckFailure.tlqNoCheckFound ? 83 : _context3.t1 === MobilePayLoadCheckFailure.tlqMultipleChecksFound ? 86 : _context3.t1 === MobilePayLoadCheckFailure.tlqLargePartyChecksFound ? 89 : _context3.t1 === MobilePayLoadCheckFailure.ERROR_CHECK_TOTAL_ZERO ? 92 : 95;
                break;

              case 46:
                this.checkModel.dialogueCode = DialogueCodes.TLQ_NOT_ENABLED_ERROR;
                this.route = Route.CALL_IN_FLOW_ERROR;
                this.checkModel.callInError = {
                  title: "Oops! Something went wrong...",
                  message: "Unable to process the request.",
                  icon: "ALERT_FAIL"
                };
                return _context3.abrupt("break", 97);

              case 50:
                this.checkModel.dialogueCode = DialogueCodes.PAYMENT_CODE_INVALID_API;

                if (this.payment.flow === PaymentFlow.MPAY_CLQ) {
                  this.checkModel.errorMessage = "Invalid Payment code.";
                  this.route = Route.CODE;
                } else {
                  this.route = Route.CALL_IN_FLOW_ERROR;
                  this.checkModel.callInError = {
                    title: "",
                    message: "Check not found.",
                    icon: "ALERT_FAIL"
                  };
                }

                return _context3.abrupt("break", 97);

              case 53:
                this.checkModel.dialogueCode = DialogueCodes.CHECK_NOT_FOUND;

                if (this.payment.flow === PaymentFlow.MPAY_CLQ) {
                  this.checkModel.errorMessage = UNABLE_TO_FIND_CHECK;
                  this.route = Route.CODE;
                } else {
                  this.route = Route.CALL_IN_FLOW_ERROR;
                  this.checkModel.callInError = {
                    title: "",
                    message: UNABLE_TO_FIND_CHECK,
                    icon: "ALERT_FAIL"
                  };
                }

                return _context3.abrupt("break", 97);

              case 56:
                this.route = Route.LOCATION_APP_ONLY;
                this.checkModel.dialogueCode = DialogueCodes.ERROR_AVAILABLE_ON_APP;
                return _context3.abrupt("break", 97);

              case 59:
                this.route = Route.LOCATION_WEB_ONLY;
                this.checkModel.dialogueCode = DialogueCodes.ERROR_AVAILABLE_ON_WEB;
                return _context3.abrupt("break", 97);

              case 62:
                this.checkModel.dialogueCode = DialogueCodes.CHECK_SATISFIED;

                if (this.payment.flow === PaymentFlow.MPAY_CLQ) {
                  this.checkModel.errorMessage = "Check has been paid.";
                  this.route = Route.CODE;
                } else {
                  this.route = Route.CALL_IN_FLOW_ERROR;
                  this.checkModel.callInError = {
                    title: "",
                    message: "Check has been paid.",
                    icon: "ALERT_FAIL"
                  };
                }

                return _context3.abrupt("break", 97);

              case 65:
                this.checkModel.dialogueCode = DialogueCodes.CHECK_SATISFIED;

                if (this.payment.flow === PaymentFlow.MPAY_CLQ) {
                  this.checkModel.errorMessage = "Check has been paid.";
                  this.route = Route.CODE;
                } else {
                  this.route = Route.CALL_IN_FLOW_ERROR;
                  this.checkModel.callInError = {
                    title: "",
                    message: "Check has been paid.",
                    icon: "ALERT_FAIL"
                  };
                }

                return _context3.abrupt("break", 97);

              case 68:
                this.checkModel.dialogueCode = DialogueCodes.CHECK_CLOSED;

                if (this.payment.flow === PaymentFlow.MPAY_CLQ) {
                  this.route = Route.CHECK_CLOSED;
                  this.checkModel.errorMessage = "This payment code and associated check has already been closed out. Please try again with another payment code.";
                } else {
                  this.route = Route.CALL_IN_FLOW_ERROR;
                  this.checkModel.callInError = {
                    title: "",
                    message: "The check has already been closed.",
                    icon: "ALERT_FAIL"
                  };
                }

                return _context3.abrupt("break", 97);

              case 71:
                this.checkModel.dialogueCode = DialogueCodes.CHECK_CLOSED;

                if (this.payment.flow === PaymentFlow.MPAY_CLQ) {
                  this.route = Route.CHECK_CLOSED;
                  this.checkModel.errorMessage = "This payment code and associated check has already been closed out. Please try again with another payment code.";
                } else {
                  this.route = Route.CALL_IN_FLOW_ERROR;
                  this.checkModel.callInError = {
                    title: "",
                    message: "The check has already been closed.",
                    icon: "ALERT_FAIL"
                  };
                }

                return _context3.abrupt("break", 97);

              case 74:
                this.route = Route.LOCATION_MOBILE_PAY_UNAVAIALABLE;
                this.checkModel.dialogueCode = DialogueCodes.ERROR_MOBILE_PAY_NOT_AVAILABLE;
                return _context3.abrupt("break", 97);

              case 77:
                if (this.payment.flow === PaymentFlow.MPAY_CLQ) {
                  this.route = Route.CODE;
                  this.checkModel.errorMessage = i18next.t("error.mp.check_total_threshold_error_mp", {
                    defaultValue: "Your check total exceeds the amount allowed to pay for your order online or mobile pay. Please contact your server and they will be happy to help you with your check."
                  });
                } else {
                  this.route = Route.CALL_IN_FLOW_ERROR;
                  this.checkModel.callInError = {
                    title: "",
                    message: this.payment.flow === PaymentFlow.MPAY_OPCIO ? i18next.t("error.mp.check_total_threshold_error_opcio", {
                      defaultValue: "Your order total exceeds the amount allowed to pay for your order online. Please pay at the restaurant when you arrive."
                    }) : i18next.t("error.mp.check_total_threshold_error_mp", {
                      defaultValue: "Your check total exceeds the amount allowed to pay for your order online or mobile pay. Please contact your server and they will be happy to help you with your check."
                    }),
                    icon: "ALERT_FAIL"
                  };
                }

                this.checkModel.dialogueCode = DialogueCodes.MAX_THRESHOLD_ERROR;
                return _context3.abrupt("break", 97);

              case 80:
                this.checkModel.dialogueCode = DialogueCodes.CONNECTIVITY_ERROR;

                if (this.payment.flow === PaymentFlow.MPAY_CLQ) {
                  this.route = Route.CODE;
                  this.checkModel.errorMessage = "Unable to process payment code. Please contact your server to settle your check.";
                } else {
                  this.route = Route.CALL_IN_FLOW_ERROR;
                  this.checkModel.callInError = {
                    title: "",
                    message: "Unable to process check. Please contact your server to settle your check.",
                    icon: "ALERT_FAIL"
                  };
                }

                return _context3.abrupt("break", 97);

              case 83:
                this.route = Route.NO_CHECK_FOUND;
                this.checkModel.dialogueCode = DialogueCodes.CHECK_NOT_FOUND;
                return _context3.abrupt("break", 97);

              case 86:
                this.route = Route.CHECK_ERROR;
                this.checkModel.dialogueCode = DialogueCodes.MULTIPLE_CHECKS_FOUND;
                return _context3.abrupt("break", 97);

              case 89:
                this.checkModel.dialogueCode = DialogueCodes.LARGE_PARTY_CHECKS_FOUND;
                this.route = Route.LARGE_PARTY_CHECKS_FOUND;
                return _context3.abrupt("break", 97);

              case 92:
                this.route = Route.NO_CHECK_FOUND;
                this.checkModel.dialogueCode = DialogueCodes.ERROR_CHECK_TOTAL_ZERO;
                return _context3.abrupt("break", 97);

              case 95:
                if (this.payment.flow === PaymentFlow.MPAY_CLQ) {
                  this.route = Route.CODE;
                  this.checkModel.errorMessage = UNABLE_TO_FIND_CHECK;
                } else {
                  this.route = Route.CALL_IN_FLOW_ERROR;
                  this.checkModel.callInError = {
                    title: "Oops! Something went wrong...",
                    message: "Unable to process the request.",
                    icon: "ALERT_FAIL"
                  };
                }

                this.checkModel.dialogueCode = DialogueCodes.ERROR_CASE_MISSING;

              case 97:
                _context3.next = 100;
                break;

              case 99:
                if (this.payment.flow === PaymentFlow.MPAY_CLQ) {
                  this.route = Route.CODE;
                  this.checkModel.dialogueCode = DialogueCodes.CHECK_NOT_FOUND;
                  this.checkModel.errorMessage = UNABLE_TO_FIND_CHECK;
                } else {
                  this.route = Route.CALL_IN_FLOW_ERROR;
                  this.checkModel.dialogueCode = DialogueCodes.ERROR_CASE_MISSING;
                  this.checkModel.callInError = {
                    title: "Oops! Something went wrong...",
                    message: "Unable to process the request.",
                    icon: "ALERT_FAIL"
                  };
                }

              case 100:
                this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "MobilePay", {
                  paymentCode: paymentCode,
                  success: false,
                  restNum: (_this$checkModel$orde4 = this.checkModel.order) === null || _this$checkModel$orde4 === void 0 ? void 0 : _this$checkModel$orde4.restNumber,
                  message: this.checkModel.errorMessage
                });

                if (this.payment.flow !== PaymentFlow.MPAY_CLQ) {
                  analyticsError.errorDescription = (_this$checkModel$call = this.checkModel.callInError) === null || _this$checkModel$call === void 0 ? void 0 : _this$checkModel$call.message;
                }

                analyticsError.errorDescription = (_analyticsError$error = analyticsError.errorDescription) !== null && _analyticsError$error !== void 0 ? _analyticsError$error : this.checkModel.errorMessage;
                this.receivedError = true;
                this.dispatchMobilePayError("".concat(analyticsError.errorCode, ": ").concat(analyticsError.errorDescription));

              case 105:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[8, 35]]);
      }));

      function loadCheck() {
        return _loadCheck.apply(this, arguments);
      }

      return loadCheck;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this4 = this,
            _this$checkModel;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.payment.deSelectGiftCards();
                this.rootStore.platformUtil.removeUrlParam("paymentCode");
                _context4.next = 4;
                return this.rootStore.platformUtil.clearSessionStorage();

              case 4:
                setTimeout(function () {
                  _this4.rootStore.platformUtil.refreshPage();
                }, 200);
                (_this$checkModel = this.checkModel) === null || _this$checkModel === void 0 ? void 0 : _this$checkModel.resetValues();
                this.route = Route.CODE;
                runInAction(function () {
                  _this4._shownInitialCheckForMPAY = false;
                });
                this.receivedError = false;
                this.payment.flow = PaymentFlow.MPAY_CLQ;
                this.showExitMobilePayDialogue = false;

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "removeCoupon",
    value: function () {
      var _removeCoupon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var couponModel, couponCode, paymentCode, _this$rootStore, _this$rootStore$user3, JWT_TOKEN, check, _this$checkModel$orde5, errorMessage;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                couponModel = this.payment.couponModel;
                couponCode = couponModel.appliedCouponCode; // TODO: Remove this later

                paymentCode = this.checkModel.paymentCode;
                _context6.prev = 3;
                _context6.next = 6;
                return (_this$rootStore = this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$user3 = _this$rootStore.user) === null || _this$rootStore$user3 === void 0 ? void 0 : _this$rootStore$user3.getTokenSilentIfLoggedIn();

              case 6:
                JWT_TOKEN = _context6.sent;
                _context6.next = 9;
                return DPServices.Check.removeCoupon(paymentCode, JWT_TOKEN, couponCode // TODO: Remove this later
                );

              case 9:
                check = _context6.sent;

                if (check) {
                  this.processCheckResponse(check);
                } else {
                  errorMessage = "Unable to process your request. Please contact your server to settle your check.";
                  this.checkModel.dialogueCode = DialogueCodes.ERROR_REMOVE_COUPON;
                  this.appMessages.showError("Coupon Code", errorMessage, null, null, null, null, this.checkModel.dialogueCode);
                  this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "applyCoupon", {
                    paymentCode: this.checkModel.paymentCode,
                    success: false,
                    restNum: (_this$checkModel$orde5 = this.checkModel.order) === null || _this$checkModel$orde5 === void 0 ? void 0 : _this$checkModel$orde5.restNumber,
                    message: errorMessage
                  });
                  this.receivedError = true;
                  this.dispatchMobilePayError("APPLY_COUPON", errorMessage);
                }

                _context6.next = 16;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](3);
                this.handleCouponErrors(_context6.t0);

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[3, 13]]);
      }));

      function removeCoupon() {
        return _removeCoupon.apply(this, arguments);
      }

      return removeCoupon;
    }()
  }, {
    key: "applyCoupon",
    value: function () {
      var _applyCoupon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var couponModel, couponCode, paymentCode, _this$rootStore2, _this$rootStore2$user, JWT_TOKEN, check, _check$order, _check$order$balance, balance;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                couponModel = this.payment.couponModel;
                couponCode = couponModel.couponCode;
                paymentCode = this.checkModel.paymentCode;
                _context7.prev = 3;
                _context7.next = 6;
                return (_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$user = _this$rootStore2.user) === null || _this$rootStore2$user === void 0 ? void 0 : _this$rootStore2$user.getTokenSilentIfLoggedIn();

              case 6:
                JWT_TOKEN = _context7.sent;
                _context7.next = 9;
                return DPServices.Check.applyCoupon(paymentCode, couponCode.trim(), JWT_TOKEN);

              case 9:
                check = _context7.sent;

                if (check) {
                  couponModel.isCouponValid = true;
                  couponModel.couponCode = "";
                  this.processCheckResponse(check); // analyticd event

                  this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "applyCoupon", {
                    success: true,
                    couponCode: couponCode ? couponCode : "",
                    discount: check !== null && check !== void 0 && check.couponDiscount ? Math.abs(check === null || check === void 0 ? void 0 : check.couponDiscount) : 0,
                    couponType: "Coupon"
                  });
                  balance = check === null || check === void 0 ? void 0 : (_check$order = check.order) === null || _check$order === void 0 ? void 0 : (_check$order$balance = _check$order.balance) === null || _check$order$balance === void 0 ? void 0 : _check$order$balance.value;

                  if (balance <= 0) {
                    this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "Payment", {
                      success: true,
                      paymentType: this.payment.activeOtherOptionTab,
                      total: this.payment.orderTotalIncludingGratuity,
                      tip: this.payment.gratuity,
                      base: this.payment.remainingOrderTotal,
                      tax: this.payment.orderPriceInfo.tax,
                      discount: this.payment.orderPriceInfo.discountAmount
                    });
                    this.route = Route.CONFIRMATION;
                  }
                } else {
                  // Failed to apply coupon code
                  couponModel.isCouponValid = false; // analyticd event

                  this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "applyCoupon", {
                    success: false,
                    couponCode: couponCode ? couponCode : "",
                    discount: 0,
                    couponType: "Coupon"
                  });
                }

                _context7.next = 17;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7["catch"](3); // analyticd event

                this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "applyCoupon", {
                  success: false,
                  couponCode: couponCode ? couponCode : "",
                  discount: 0,
                  couponType: "Coupon"
                });
                this.handleCouponErrors(_context7.t0);

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[3, 13]]);
      }));

      function applyCoupon() {
        return _applyCoupon.apply(this, arguments);
      }

      return applyCoupon;
    }()
  }, {
    key: "handleCouponErrors",
    value: function handleCouponErrors(errorObj) {
      var _couponError$message,
          _couponError$title,
          _this5 = this;

      var couponError = DPServices.Common.handleUIErrorAndOverride(errorObj, {
        title: "",
        message: ""
      }); // updating value to null so can use "??"

      couponError.message = (_couponError$message = couponError.message) !== null && _couponError$message !== void 0 && _couponError$message.length ? couponError.message : null;
      couponError.title = (_couponError$title = couponError.title) !== null && _couponError$title !== void 0 && _couponError$title.length ? couponError.title : null;
      var couponModel = this.payment.couponModel;
      var analyticsError = {};
      analyticsError.errorCode = couponError.errorCode;

      if (couponError.errorCode) {
        var _this$checkModel$orde6;

        switch (couponError.errorCode) {
          case MobilePayCouponErrors.paymentExceptions:
          case MobilePayCouponErrors.ERROR_GENERIC_PAYMENT_FAILURE:
          case MobilePayCouponErrors.ERROR_GENERIC_COUPON_FAILURE:
          case MobilePayCouponErrors.ERROR_COUPON_MANUAL_OVERRIDE:
            {
              var _couponError$title2, _couponError$message2, _couponError$message3;

              if (couponError.errorCode === MobilePayCouponErrors.paymentExceptions) {
                this.checkModel.dialogueCode = DialogueCodes.ERROR_PAYMENT_EXCEPTIONS;
              } else {
                this.checkModel.dialogueCode = DialogueCodes.ERROR_APPLY_COUPON_FAILURE;
              }

              this.appMessages.showError((_couponError$title2 = couponError.title) !== null && _couponError$title2 !== void 0 ? _couponError$title2 : "Coupon Code", (_couponError$message2 = couponError.message) !== null && _couponError$message2 !== void 0 ? _couponError$message2 : "Unable to process your request. Please contact your server to settle your check.", null, null, null, null, this.checkModel.dialogueCode);
              analyticsError.errorDescription = (_couponError$message3 = couponError.message) !== null && _couponError$message3 !== void 0 ? _couponError$message3 : "Unable to process your request. Please contact your server to settle your check.";
              break;
            }

          case MobilePayCouponErrors.ERROR_CHECK_NOT_FOUND:
          case MobilePayCouponErrors.checkNotFound:
          case MobilePayCouponErrors.ERROR_CHECK_CLOSED:
          case MobilePayCouponErrors.closedCheck:
            {
              var _couponError$title3, _couponError$message4, _couponError$message5;

              if (couponError.errorCode === MobilePayCouponErrors.checkNotFound || couponError.errorCode === MobilePayCouponErrors.ERROR_CHECK_NOT_FOUND) {
                this.checkModel.dialogueCode = DialogueCodes.CHECK_NOT_FOUND;
              } else {
                this.checkModel.dialogueCode = DialogueCodes.CHECK_CLOSED;
              }

              this.appMessages.showError((_couponError$title3 = couponError.title) !== null && _couponError$title3 !== void 0 ? _couponError$title3 : "Check", (_couponError$message4 = couponError.message) !== null && _couponError$message4 !== void 0 ? _couponError$message4 : "This payment code and associated check has already been closed out. Please try again with another payment code.", null, {
                undismissible: true,
                okBtnText: "Ok",
                okBtnOnClick: function okBtnOnClick() {
                  _this5.route = Route.CODE;
                }
              }, null, null, this.checkModel.dialogueCode);
              analyticsError.errorDescription = (_couponError$message5 = couponError.message) !== null && _couponError$message5 !== void 0 ? _couponError$message5 : "This payment code and associated check has already been closed out. Please try again with another payment code.";
              break;
            }

          case MobilePayCouponErrors.ERROR_CHECK_SATISFIED:
          case MobilePayCouponErrors.checkSatisfiedError:
            {
              var _couponError$title4, _couponError$message6, _couponError$message7;

              this.checkModel.dialogueCode = DialogueCodes.CHECK_SATISFIED;
              this.route = Route.CODE;
              this.appMessages.showError((_couponError$title4 = couponError.title) !== null && _couponError$title4 !== void 0 ? _couponError$title4 : "Check", (_couponError$message6 = couponError.message) !== null && _couponError$message6 !== void 0 ? _couponError$message6 : "Check has been paid. Please contact your server.", null, {
                undismissible: true,
                okBtnText: "Ok",
                okBtnOnClick: function okBtnOnClick() {
                  _this5.route = Route.CODE;
                }
              }, null, null, this.checkModel.dialogueCode);
              analyticsError.errorDescription = (_couponError$message7 = couponError.message) !== null && _couponError$message7 !== void 0 ? _couponError$message7 : "Check has been paid. Please contact your server.";
              break;
            }

          case MobilePayCouponErrors.couponExceptions:
          case MobilePayCouponErrors.ERROR_COUPON_NOT_APPLICABLE:
          case MobilePayCouponErrors.ERROR_INVALID_COUPON:
            {
              this.checkModel.dialogueCode = DialogueCodes.ERROR_COUPON_NOT_APPLICABLE_OR_INVALID;
              couponModel.isCouponValid = false;
              break;
            }

          case MobilePayCouponErrors.ERROR_CHECK_LOCKED:
          case MobilePayCouponErrors.ERROR_CHECK_VERSION_MISMATCH:
          case MobilePayCouponErrors.lockOrderError:
            {
              if (couponError.errorCode !== MobilePayCouponErrors.ERROR_CHECK_VERSION_MISMATCH) {
                this.checkModel.dialogueCode = DialogueCodes.PAYMENT_LOCK_ORDER_ERROR;
              } else {
                this.checkModel.dialogueCode = DialogueCodes.ERROR_CHECK_VERSION_MISMATCH;
              }

              this.route = Route.CHECK_UPDATED;
              break;
            }

          case MobilePayCouponErrors.ERROR_BFAULT:
          case MobilePayCouponErrors.ERROR_TFAULT:
          case MobilePayCouponErrors.ERROR_DP_INVALID_COUPON:
            {
              var _couponError$title5, _couponError$message8;

              this.checkModel.dialogueCode = DialogueCodes.ERROR_COUPON_NOT_APPLICABLE_OR_INVALID;
              this.appMessages.showError((_couponError$title5 = couponError.title) !== null && _couponError$title5 !== void 0 ? _couponError$title5 : "Oops! Something went wrong", (_couponError$message8 = couponError.message) !== null && _couponError$message8 !== void 0 ? _couponError$message8 : "Invalid coupon code", null, null, null, null, this.checkModel.dialogueCode);
              couponModel.isCouponValid = false;
              break;
            }

          default:
            {
              this.checkModel.dialogueCode = DialogueCodes.ERROR_CASE_MISSING;
              this.appMessages.showError("Coupon", "Unable to process request. Please contact your server to settle your check.", null, null, null, null, this.checkModel.dialogueCode);
              couponModel.isCouponValid = false;
              analyticsError.errorDescription = "Unable to process request. Please contact your server to settle your check.";
              break;
            }
        }

        this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "applyCoupon", {
          paymentCode: this.checkModel.paymentCode,
          success: false,
          restNum: (_this$checkModel$orde6 = this.checkModel.order) === null || _this$checkModel$orde6 === void 0 ? void 0 : _this$checkModel$orde6.restNumber,
          message: couponError.errorCode
        });
      } else {
        var _this$checkModel$orde7;

        couponModel.isCouponValid = false;
        this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "applyCoupon", {
          paymentCode: this.checkModel.paymentCode,
          success: false,
          restNum: (_this$checkModel$orde7 = this.checkModel.order) === null || _this$checkModel$orde7 === void 0 ? void 0 : _this$checkModel$orde7.restNumber,
          message: "Failed to process coupon."
        });
        analyticsError.errorCode = "APPLY_COUPON";
        analyticsError.errorDescription = "Failed to process coupon.";
      }

      this.checkModel.dialogueCode = DialogueCodes.ERROR_APPLY_COUPON_FAILURE;
      this.appMessages.showError("Coupon", "The applied coupon has expired or is invalid.", null, null, null, null, this.checkModel.dialogueCode);
      this.receivedError = true;
      this.dispatchMobilePayError(analyticsError.errorCode, analyticsError.errorDescription);
    }
  }, {
    key: "payPalSubmitOrder",
    value: function () {
      var _payPalSubmitOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(approvalData, deviceData) {
        var tokenData, processingError, merchantId, _yield$handle, _yield$handle2, error, payPalData;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                tokenData = null;

                if (!(this.payment.flow === PaymentFlow.MPAY_OPCIO)) {
                  _context8.next = 18;
                  break;
                }

                processingError = null; // Support for Pay Now - CALLIN/ETOGO flow

                merchantId = this.appAttributes.partialAVSmerchantID;
                _context8.next = 6;
                return handle(this.payment.tokenizePayPalRSA(this.appAttributes.paymentCorrelationId, approvalData, deviceData, merchantId, "MOBILE_PAY"));

              case 6:
                _yield$handle = _context8.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 1);
                error = _yield$handle2[0];

                if (!error) {
                  _context8.next = 17;
                  break;
                }

                this.checkModel.dialogueCode = DialogueCodes.PAYPAL_PAYMENT_FAILED;
                this.appMessages.showError("PayPal Payment Failed", "PayPal authorization failed. Please try again.", null, null, null, null, this.checkModel.dialogueCode);
                this.receivedError = true;
                this.dispatchMobilePayError("PayPal Payment Failed", "PayPal authorization failed. Please try again.");
                return _context8.abrupt("return");

              case 17:
                tokenData = this.payment.payPalData.tokenData;

              case 18:
                if (!(approvalData && deviceData)) {
                  _context8.next = 25;
                  break;
                }

                payPalData = {
                  approvalData: approvalData,
                  deviceData: deviceData,
                  tokenData: tokenData
                };
                this.payment.payPalData = payPalData;
                _context8.next = 23;
                return this.payCheck();

              case 23:
                _context8.next = 29;
                break;

              case 25:
                this.checkModel.dialogueCode = DialogueCodes.PAYPAL_AUTHORIZATION_FAILED;
                this.appMessages.showError("PayPal Payment", "PayPal authorization failed. Please try again.", null, null, null, null, this.checkModel.dialogueCode);
                this.receivedError = true;
                this.dispatchMobilePayError("PayPal Payment", "PayPal authorization failed. Please try again.");

              case 29:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function payPalSubmitOrder(_x2, _x3) {
        return _payPalSubmitOrder.apply(this, arguments);
      }

      return payPalSubmitOrder;
    }()
  }, {
    key: "payPalCancel",
    value: function payPalCancel(errData) {
      this.checkModel.dialogueCode = DialogueCodes.PAYPAL_PAYMENT_CANCELLED;
      this.appMessages.showError("PayPal", "PayPal payment cancelled. Please try again.", null, null, null, null, this.checkModel.dialogueCode);
      Logger.log(errData);
      this.receivedError = true;
      this.dispatchMobilePayError(JSON.stringify(errData));
    }
  }, {
    key: "payPalErrored",
    value: function payPalErrored(errData) {
      this.payment.payPalErrored = true;
      Logger.log(errData);
      this.receivedError = true;
      this.dispatchMobilePayError("PayPal_ERRORED", JSON.stringify(errData));
    }
  }, {
    key: "validateSubmitOrder",
    value: function validateSubmitOrder() {
      if (!this.isValid) {
        var payment = this.payment;
        var isLoggedIn = this.rootStore.user.isLoggedIn;
        this.formState.submitCount = this.formState.submitCount + 1;
        this.rootStore.common.accordionModel.setFormSubmitted();

        if (!payment.isValid) {
          payment.handleInvalidModel(this.appMessages, this.rootStore.isMobile);
          return false;
        }

        if (!isLoggedIn && !this.emailReceiptModel.isValid) {
          this.emailReceiptModel.handleInvalidModel(this.appMessages);
          return false;
        }

        if (!this.payment.gratuityModel.isValid) {
          this.payment.gratuityModel.handleInvalidModel(this.appMessages);
          return false;
        }

        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "processTheProcessingError",
    value: function processTheProcessingError(processingError) {
      if (processingError) {
        var analyticsError = {};
        analyticsError.errorCode = processingError.message;

        if (processingError === ERRORS.CC_TOKENIZATION_BUSINESS_FAULT) {
          this.checkModel.dialogueCode = DialogueCodes.ERROR_CC_TOKENIZATION_BUSINESS_FAULT;
          this.appMessages.showError("Credit Card", "Sorry, we're unable to process your request. Please verify card details and re-try or use a different card.", null, null, null, null, this.checkModel.dialogueCode);
          analyticsError.errorDescription = "Sorry, we're unable to process your request. Please verify card details and re-try or use a different card.";
        }

        if (processingError === ERRORS.CC_TOKENIZATION_TECHNICAL_FAILURE || processingError === ERRORS.ERROR_SESSION_TOKEN_FAILURE) {
          if (processingError === ERRORS.CC_TOKENIZATION_TECHNICAL_FAILURE) {
            this.checkModel.dialogueCode = DialogueCodes.ERROR_CC_TOKENIZATION_TECHNICAL_FAILURE;
          } else {
            this.checkModel.dialogueCode = DialogueCodes.ERROR_ORDER_SESSION_TOKEN_FAILURE;
          }

          this.appMessages.showError("Payment", "Unfortunately, We are unable to process Credit / Debit Card Payments right now. Please use a different payment method or contact your server to settle your check.", null, null, null, null, this.checkModel.dialogueCode);
          analyticsError.errorDescription = "Unfortunately, We are unable to process Credit / Debit Card Payments right now. Please use a different payment method or contact your server to settle your check.";
        }

        if (processingError === ERRORS.PAY_AT_RESTAURANT_NOT_SUPPORTED || processingError === ERRORS.INVALID_ORDER_TOTAL) {
          if (processingError === ERRORS.PAY_AT_RESTAURANT_NOT_SUPPORTED) {
            this.checkModel.dialogueCode = DialogueCodes.ERROR_PAY_AT_RESTAURANT_NOT_SUPPORTED;
          } else {
            this.checkModel.dialogueCode = DialogueCodes.ERROR_INVALID_ORDER_TOTAL;
          }

          this.route = Route.PAYMENT_FAILURE;
        }

        if (processingError === ERRORS.CHECK_NOT_LOADED) {
          this.checkModel.dialogueCode = DialogueCodes.ERROR_CHECK_NOT_LOADED;
          this.handleSessionExpiry();
        }

        this.receivedError = true;
        this.dispatchMobilePayError(analyticsError.errorCode, analyticsError.errorDescription);
      } else {
        this.checkModel.dialogueCode = DialogueCodes.ERROR_CASE_MISSING;
        this.route = Route.PAYMENT_FAILURE;
        this.receivedError = true;
        this.dispatchMobilePayError("PAYMENT_FAILURE");
      }
    }
  }, {
    key: "getCreditCardTokenizationAttributes",
    value: function getCreditCardTokenizationAttributes(isFullAVSEnabled) {
      return {
        merchantId: isFullAVSEnabled ? this.appAttributes.fullAVSmerchantID : this.appAttributes.partialAVSmerchantID,
        paymentCorrelationId: this.appAttributes.paymentCorrelationId,
        dashCheckId: this.checkModel.dashCheckId
      };
    } // function is used to tokenize the credit-card number on completing the form

  }, {
    key: "tokenizeCreditCardAndHandleErrors",
    value: function () {
      var _tokenizeCreditCardAndHandleErrors = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this$getCreditCardTo, merchantId, dashCheckId, paymentCorrelationId, _yield$handle3, _yield$handle4, processingError;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (this.payment.creditCardInfo.paymentToken) {
                  _context9.next = 8;
                  break;
                }

                _this$getCreditCardTo = this.getCreditCardTokenizationAttributes(this.payment.creditCardInfo.fullAVSEnabled), merchantId = _this$getCreditCardTo.merchantId, dashCheckId = _this$getCreditCardTo.dashCheckId, paymentCorrelationId = _this$getCreditCardTo.paymentCorrelationId;
                _context9.next = 4;
                return handle(this.payment.tokenizeCreditCardPayment(merchantId, paymentCorrelationId, dashCheckId, "MOBILE_PAY"));

              case 4:
                _yield$handle3 = _context9.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 1);
                processingError = _yield$handle4[0];

                if (processingError) {
                  this.processTheProcessingError(processingError);
                }

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function tokenizeCreditCardAndHandleErrors() {
        return _tokenizeCreditCardAndHandleErrors.apply(this, arguments);
      }

      return tokenizeCreditCardAndHandleErrors;
    }()
  }, {
    key: "payCheck",
    value: function () {
      var _payCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _this6 = this;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", new Promise(function (resolve) {
                  runInAction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                    var valid, processingError, payCheckRequest, canProceedWithSubmitOrder, orderTotal, activePaymentTab, activePaymentOptionTab, gcPayments, savedCCPayment, merchantId, _yield$handle5, _yield$handle6, error, _this6$getCreditCardT, dashCheckId, _merchantId, paymentCorrelationId, _yield$handle7, _yield$handle8, _error, ccFormPayment, _applePayment$billing, _applePayment$billing3, _applePayment$billing4, _applePayment$billing5, _applePayment$billing6, _applePayment$billing7, _applePayment$billing8, _applePayment$billing9, _applePayment$billing10, _applePayment$billing11, _applePayment$billing12, _applePayment$billing13, _applePayment$billing14, _applePayment$token, _applePayment$token2, _applePayment$token3, _this6$payment$appleP, _this6$payment$appleP2, _this6$payment$appleP3, _this6$payment$appleP4, _this6$payment$appleP5, _this6$payment$appleP6, _applePayment$billing15, _applePayment$shippin, applePayment, _applePayment$billing2, emailAddress, googlePayAuthorization, googlePaymentPayload, _paypalPayment$billin, _paypalPayment$billin2, _paypalPayment$billin3, _paypalPayment$billin4, _paypalPayment$billin5, _paypalPayment$billin6, _paypalPayment$billin7, _paypalPayment$billin8, _paypalPayment$billin9, _this6$payment$payPal, _this6$payment$payPal2, _this6$payment$payPal3, _this6$payment$payPal4, _this6$payment$payPal5, _this6$payment$payPal6, _this6$payment$payPal7, _this6$payment$payPal8, _this6$payment$payPal9, _this6$payment$payPal10, _this6$payment$payPal11, _this6$payment$payPal12, _this6$payment$payPal13, _this6$payment$payPal14, _this6$payment$payPal15, _paypalPayment$billin10, _paypalPayment$billin11, paypalPayment, _order$order4, _order$order4$balance, emailId, JWT_TOKEN, order, balance, _this6$checkModel$ord, _this6$checkModel$ord2, _this6$checkModel$ord3, _this6$checkModel$ord4, _loadCheckError$messa2, _this6$checkModel$ord5, loadCheckError, analyticsError, _loadCheckError$title, _this6$checkModel$ord6;

                    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            valid = _this6.validateSubmitOrder();
                            processingError = null;

                            if (!valid) {
                              _context10.next = 124;
                              break;
                            }

                            _context10.prev = 3;
                            _this6.formState.apiFiredCount = _this6.formState.apiFiredCount + 1;
                            _this6.formState.isSubmitting = true;
                            payCheckRequest = {
                              customerLocalDate: getLocalISODateString(moment().toDate()),
                              emailId: _this6.emailReceiptModel.emailId,
                              paymentCode: _this6.checkModel.paymentCode,
                              correlationId: _this6.mobilePayAppAttributes.paymentCorrelationId,
                              paymentCollection: []
                            };
                            canProceedWithSubmitOrder = true;
                            orderTotal = _this6.payment.orderTotalIncludingGratuity;

                            if (!(orderTotal > 0)) {
                              _context10.next = 53;
                              break;
                            }

                            activePaymentTab = _this6.payment.activePaymentTab;
                            activePaymentOptionTab = _this6.payment.activeOtherOptionTab;

                            if (!(activePaymentTab === PaymentMethods.ONLINE)) {
                              _context10.next = 49;
                              break;
                            } //online payment


                            if (_this6.payment.isAnyGiftCardSelected) {
                              gcPayments = _this6.payment.gcPaymentPayload;
                              payCheckRequest.paymentCollection.push(gcPayments);
                            }

                            if (_this6.payment.isSelectedGiftCardsSufficient) {
                              _context10.next = 47;
                              break;
                            }

                            if (!_this6.payment.isSavedCreditCardSelected) {
                              _context10.next = 29;
                              break;
                            } // Saved Credit Card selected


                            savedCCPayment = _this6.payment.savedCCPaymentPayload;

                            if (!savedCCPayment.paymentCVV) {
                              _context10.next = 25;
                              break;
                            }

                            merchantId = _this6.appAttributes.partialAVSmerchantID;
                            _context10.next = 21;
                            return handle(_this6.payment.validateSecurityCode(_this6.appAttributes.paymentCorrelationId, _this6.checkModel.dashCheckId, "MOBILE_PAY", savedCCPayment, merchantId));

                          case 21:
                            _yield$handle5 = _context10.sent;
                            _yield$handle6 = _slicedToArray(_yield$handle5, 1);
                            error = _yield$handle6[0];

                            if (error) {
                              processingError = error;
                              canProceedWithSubmitOrder = false;
                            }

                          case 25:
                            delete savedCCPayment["paymentCVV"];
                            payCheckRequest.paymentCollection.push({
                              transType: "TOG",
                              creditCards: [savedCCPayment]
                            });
                            _context10.next = 47;
                            break;

                          case 29:
                            if (!(activePaymentTab === PaymentMethods.ONLINE)) {
                              _context10.next = 47;
                              break;
                            }

                            if (!(activePaymentOptionTab === OnlinePaymentTypes.CREDIT_CARD)) {
                              _context10.next = 44;
                              break;
                            }

                            if (!_this6.payment.creditCardInfo.isValid) {
                              _context10.next = 43;
                              break;
                            }

                            if (_this6.payment.creditCardInfo.paymentToken) {
                              _context10.next = 40;
                              break;
                            }

                            _this6$getCreditCardT = _this6.getCreditCardTokenizationAttributes(_this6.payment.creditCardInfo.fullAVSEnabled), dashCheckId = _this6$getCreditCardT.dashCheckId, _merchantId = _this6$getCreditCardT.merchantId, paymentCorrelationId = _this6$getCreditCardT.paymentCorrelationId;
                            _context10.next = 36;
                            return handle(_this6.payment.tokenizeCreditCardPayment(_merchantId, paymentCorrelationId, dashCheckId, "MOBILE_PAY"));

                          case 36:
                            _yield$handle7 = _context10.sent;
                            _yield$handle8 = _slicedToArray(_yield$handle7, 1);
                            _error = _yield$handle8[0];

                            if (_error) {
                              processingError = _error;
                            }

                          case 40:
                            if (!_this6.payment.creditCardInfo.isCCError) {
                              ccFormPayment = _this6.payment.formCCPaymentPayload;
                              delete ccFormPayment["paymentCVV"];
                              payCheckRequest.paymentCollection.push({
                                transType: "TOG",
                                creditCards: [ccFormPayment]
                              });
                            } else {
                              canProceedWithSubmitOrder = false;
                            }

                            _context10.next = 44;
                            break;

                          case 43:
                            canProceedWithSubmitOrder = false;

                          case 44:
                            if (activePaymentOptionTab === OnlinePaymentTypes.APPLE_PAY) {
                              if (_this6.payment.applePayAuthorization) {
                                applePayment = _this6.payment.applePayAuthorization;

                                if ((_applePayment$billing = applePayment.billingContact) !== null && _applePayment$billing !== void 0 && _applePayment$billing.countryCode) {
                                  applePayment.billingContact.countryCode = (_applePayment$billing2 = applePayment.billingContact.countryCode) === null || _applePayment$billing2 === void 0 ? void 0 : _applePayment$billing2.toUpperCase();
                                }

                                payCheckRequest.paymentCollection.push({
                                  wallet: {
                                    transType: "APP",
                                    billingInfo: {
                                      addressLines: (_applePayment$billing3 = applePayment.billingContact) === null || _applePayment$billing3 === void 0 ? void 0 : _applePayment$billing3.addressLines
                                    },
                                    administrativeArea: (_applePayment$billing4 = applePayment.billingContact) === null || _applePayment$billing4 === void 0 ? void 0 : _applePayment$billing4.administrativeArea,
                                    country: (_applePayment$billing5 = applePayment.billingContact) === null || _applePayment$billing5 === void 0 ? void 0 : _applePayment$billing5.country,
                                    countryCode: (_applePayment$billing6 = applePayment.billingContact) === null || _applePayment$billing6 === void 0 ? void 0 : _applePayment$billing6.countryCode,
                                    familyName: (_applePayment$billing7 = applePayment.billingContact) === null || _applePayment$billing7 === void 0 ? void 0 : _applePayment$billing7.familyName,
                                    givenName: (_applePayment$billing8 = applePayment.billingContact) === null || _applePayment$billing8 === void 0 ? void 0 : _applePayment$billing8.givenName,
                                    locality: (_applePayment$billing9 = applePayment.billingContact) === null || _applePayment$billing9 === void 0 ? void 0 : _applePayment$billing9.locality,
                                    phoneticFamilyName: (_applePayment$billing10 = applePayment.billingContact) === null || _applePayment$billing10 === void 0 ? void 0 : _applePayment$billing10.phoneticFamilyName,
                                    phoneticGivenName: (_applePayment$billing11 = applePayment.billingContact) === null || _applePayment$billing11 === void 0 ? void 0 : _applePayment$billing11.phoneticGivenName,
                                    postalCode: (_applePayment$billing12 = applePayment.billingContact) === null || _applePayment$billing12 === void 0 ? void 0 : _applePayment$billing12.postalCode,
                                    subAdministrativeArea: (_applePayment$billing13 = applePayment.billingContact) === null || _applePayment$billing13 === void 0 ? void 0 : _applePayment$billing13.subAdministrativeArea,
                                    subLocality: (_applePayment$billing14 = applePayment.billingContact) === null || _applePayment$billing14 === void 0 ? void 0 : _applePayment$billing14.subLocality,
                                    transactionInfo: {
                                      paymentData: (_applePayment$token = applePayment.token) === null || _applePayment$token === void 0 ? void 0 : _applePayment$token.paymentData,
                                      paymentMethod: (_applePayment$token2 = applePayment.token) === null || _applePayment$token2 === void 0 ? void 0 : _applePayment$token2.paymentMethod,
                                      transactionIdentifier: (_applePayment$token3 = applePayment.token) === null || _applePayment$token3 === void 0 ? void 0 : _applePayment$token3.transactionIdentifier
                                    },
                                    amount: (_this6$payment$appleP = _this6.payment.applePayPaymentPayload) === null || _this6$payment$appleP === void 0 ? void 0 : (_this6$payment$appleP2 = _this6$payment$appleP.applePayPayment) === null || _this6$payment$appleP2 === void 0 ? void 0 : _this6$payment$appleP2.amount,
                                    tipAmount: (_this6$payment$appleP3 = _this6.payment.applePayPaymentPayload) === null || _this6$payment$appleP3 === void 0 ? void 0 : (_this6$payment$appleP4 = _this6$payment$appleP3.applePayPayment) === null || _this6$payment$appleP4 === void 0 ? void 0 : _this6$payment$appleP4.tipAmount,
                                    currencyCode: (_this6$payment$appleP5 = _this6.payment.applePayPaymentPayload) === null || _this6$payment$appleP5 === void 0 ? void 0 : (_this6$payment$appleP6 = _this6$payment$appleP5.applePayPayment) === null || _this6$payment$appleP6 === void 0 ? void 0 : _this6$payment$appleP6.currencyCode,
                                    sdkVersion: "EC_v1"
                                  }
                                });
                                emailAddress = ((_applePayment$billing15 = applePayment.billingContact) === null || _applePayment$billing15 === void 0 ? void 0 : _applePayment$billing15.emailAddress) || ((_applePayment$shippin = applePayment.shippingContact) === null || _applePayment$shippin === void 0 ? void 0 : _applePayment$shippin.emailAddress);

                                if (emailAddress && !payCheckRequest.emailId) {
                                  payCheckRequest.emailId = emailAddress;
                                }
                              } else {
                                canProceedWithSubmitOrder = false;
                              }
                            }

                            if (activePaymentOptionTab === OnlinePaymentTypes.GOOGLE_PAY) {
                              if (_this6.payment.googlePayAuthorization) {
                                googlePayAuthorization = _this6.payment.googlePayAuthorization;
                                googlePaymentPayload = _this6.payment.googlePayPaymentPayload;
                                payCheckRequest.paymentCollection.push({
                                  wallet: {
                                    transType: "GP",
                                    billingInfo: {
                                      cardNetwork: googlePaymentPayload.googlePayPayment.billingInfo.cardNetwork,
                                      cardDetails: Number(googlePaymentPayload.googlePayPayment.billingInfo.cardDetails),
                                      billingAddress: {
                                        address3: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.address3,
                                        sortingCode: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.sortingCode,
                                        address2: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.address2,
                                        countryCode: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.countryCode,
                                        address1: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.address1,
                                        postalCode: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.postalCode,
                                        name: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.name,
                                        locality: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.locality,
                                        administrativeArea: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.administrativeArea
                                      }
                                    },
                                    transactionInfo: {
                                      description: googlePaymentPayload.googlePayPayment.transcationInfo.description,
                                      tokenizationData: googlePaymentPayload.googlePayPayment.transcationInfo.tokenizationData,
                                      type: googlePaymentPayload.googlePayPayment.transcationInfo.type
                                    },
                                    amount: googlePaymentPayload.googlePayPayment.amount,
                                    tipAmount: googlePaymentPayload.googlePayPayment.tipAmount,
                                    currencyCode: googlePaymentPayload.googlePayPayment.currencyCode,
                                    sdkVersion: "ECv1"
                                  }
                                });

                                if (googlePayAuthorization.email) {
                                  payCheckRequest.emailId = googlePayAuthorization.email;
                                }
                              } else {
                                canProceedWithSubmitOrder = false;
                              }
                            }

                            if (activePaymentOptionTab === OnlinePaymentTypes.PAYPAL) {
                              if (_this6.payment.payPalData) {
                                paypalPayment = _this6.payment.payPalPaymentPayloadMP;
                                payCheckRequest.paymentCollection.push({
                                  wallet: {
                                    transType: "PPP",
                                    billingInfo: {
                                      firstName: (_paypalPayment$billin = paypalPayment.billingInfo) === null || _paypalPayment$billin === void 0 ? void 0 : _paypalPayment$billin.firstName,
                                      lastName: (_paypalPayment$billin2 = paypalPayment.billingInfo) === null || _paypalPayment$billin2 === void 0 ? void 0 : _paypalPayment$billin2.lastName,
                                      email: (_paypalPayment$billin3 = paypalPayment.billingInfo) === null || _paypalPayment$billin3 === void 0 ? void 0 : _paypalPayment$billin3.email,
                                      phone: (_paypalPayment$billin4 = paypalPayment.billingInfo) === null || _paypalPayment$billin4 === void 0 ? void 0 : _paypalPayment$billin4.phone,
                                      line1: (_paypalPayment$billin5 = paypalPayment.billingInfo) === null || _paypalPayment$billin5 === void 0 ? void 0 : _paypalPayment$billin5.line1,
                                      city: (_paypalPayment$billin6 = paypalPayment.billingInfo) === null || _paypalPayment$billin6 === void 0 ? void 0 : _paypalPayment$billin6.city,
                                      postalCode: (_paypalPayment$billin7 = paypalPayment.billingInfo) === null || _paypalPayment$billin7 === void 0 ? void 0 : _paypalPayment$billin7.postalCode,
                                      state: (_paypalPayment$billin8 = paypalPayment.billingInfo) === null || _paypalPayment$billin8 === void 0 ? void 0 : _paypalPayment$billin8.state,
                                      countryCode: (_paypalPayment$billin9 = paypalPayment.billingInfo) === null || _paypalPayment$billin9 === void 0 ? void 0 : _paypalPayment$billin9.countryCode
                                    },
                                    transactionInfo: {
                                      nonce: (_this6$payment$payPal = _this6.payment.payPalData) === null || _this6$payment$payPal === void 0 ? void 0 : (_this6$payment$payPal2 = _this6$payment$payPal.approvalData) === null || _this6$payment$payPal2 === void 0 ? void 0 : _this6$payment$payPal2.nonce,
                                      type: "PayPalAccount",
                                      correlationId: (_this6$payment$payPal3 = _this6.payment.payPalData) === null || _this6$payment$payPal3 === void 0 ? void 0 : (_this6$payment$payPal4 = _this6$payment$payPal3.deviceData) === null || _this6$payment$payPal4 === void 0 ? void 0 : _this6$payment$payPal4.correlation_id,
                                      payerId: (_this6$payment$payPal5 = _this6.payment.payPalData) === null || _this6$payment$payPal5 === void 0 ? void 0 : (_this6$payment$payPal6 = _this6$payment$payPal5.approvalData) === null || _this6$payment$payPal6 === void 0 ? void 0 : (_this6$payment$payPal7 = _this6$payment$payPal6.details) === null || _this6$payment$payPal7 === void 0 ? void 0 : _this6$payment$payPal7.payerId,
                                      cardAlias: Number((_this6$payment$payPal8 = _this6.payment.payPalData) === null || _this6$payment$payPal8 === void 0 ? void 0 : (_this6$payment$payPal9 = _this6$payment$payPal8.tokenData) === null || _this6$payment$payPal9 === void 0 ? void 0 : _this6$payment$payPal9.alias),
                                      expirationMonth: (_this6$payment$payPal10 = _this6.payment.payPalData) === null || _this6$payment$payPal10 === void 0 ? void 0 : (_this6$payment$payPal11 = _this6$payment$payPal10.tokenData) === null || _this6$payment$payPal11 === void 0 ? void 0 : _this6$payment$payPal11.expiryMonth,
                                      expirationYear: (_this6$payment$payPal12 = _this6.payment.payPalData) === null || _this6$payment$payPal12 === void 0 ? void 0 : (_this6$payment$payPal13 = _this6$payment$payPal12.tokenData) === null || _this6$payment$payPal13 === void 0 ? void 0 : _this6$payment$payPal13.expiryYear,
                                      paymentCardToken: (_this6$payment$payPal14 = _this6.payment.payPalData) === null || _this6$payment$payPal14 === void 0 ? void 0 : (_this6$payment$payPal15 = _this6$payment$payPal14.tokenData) === null || _this6$payment$payPal15 === void 0 ? void 0 : _this6$payment$payPal15.paypalToken,
                                      firstName: (paypalPayment === null || paypalPayment === void 0 ? void 0 : (_paypalPayment$billin10 = paypalPayment.billingInfo) === null || _paypalPayment$billin10 === void 0 ? void 0 : _paypalPayment$billin10.firstName) || "",
                                      lastName: (paypalPayment === null || paypalPayment === void 0 ? void 0 : (_paypalPayment$billin11 = paypalPayment.billingInfo) === null || _paypalPayment$billin11 === void 0 ? void 0 : _paypalPayment$billin11.lastName) || ""
                                    },
                                    amount: paypalPayment === null || paypalPayment === void 0 ? void 0 : paypalPayment.amount,
                                    tipAmount: paypalPayment === null || paypalPayment === void 0 ? void 0 : paypalPayment.tipAmount,
                                    currencyCode: "USD"
                                  }
                                });
                              } else {
                                canProceedWithSubmitOrder = false;
                              }
                            }

                          case 47:
                            _context10.next = 51;
                            break;

                          case 49:
                            canProceedWithSubmitOrder = false;
                            processingError = ERRORS.PAY_AT_RESTAURANT_NOT_SUPPORTED;

                          case 51:
                            _context10.next = 55;
                            break;

                          case 53:
                            canProceedWithSubmitOrder = false;
                            processingError = ERRORS.INVALID_ORDER_TOTAL;

                          case 55:
                            if (!canProceedWithSubmitOrder) {
                              _context10.next = 70;
                              break;
                            } //Fire Submit Order API


                            emailId = _this6.emailReceiptModel.emailId;

                            if (emailId) {
                              payCheckRequest.emailId = emailId;
                            }

                            _context10.next = 60;
                            return _this6.rootStore.user.getTokenSilentIfLoggedIn();

                          case 60:
                            JWT_TOKEN = _context10.sent;
                            _context10.next = 63;
                            return DPServices.Check.payCheck(payCheckRequest, JWT_TOKEN);

                          case 63:
                            order = _context10.sent;
                            resolve({
                              status: "SUCCESS"
                            });
                            balance = order === null || order === void 0 ? void 0 : (_order$order4 = order.order) === null || _order$order4 === void 0 ? void 0 : (_order$order4$balance = _order$order4.balance) === null || _order$order4$balance === void 0 ? void 0 : _order$order4$balance.value;

                            if (balance <= 0) {
                              _this6.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "Payment", {
                                success: true,
                                restNum: (_this6$checkModel$ord = _this6.checkModel.order) === null || _this6$checkModel$ord === void 0 ? void 0 : _this6$checkModel$ord.restNumber,
                                paymentType: _this6.payment.activeOtherOptionTab,
                                total: _this6.payment.orderTotalIncludingGratuity,
                                tip: _this6.payment.gratuity,
                                base: _this6.payment.remainingOrderTotal,
                                tax: _this6.payment.orderPriceInfo.tax,
                                discount: _this6.payment.orderPriceInfo.discountAmount
                              });

                              _this6.processCheckResponse(order);

                              _this6.sendEmailReceiptRequest();

                              _this6.rootStore.platformUtil.clearSessionStorage()["finally"](function () {
                                _this6.route = Route.CONFIRMATION;
                              });
                            } else {
                              _this6.processCheckResponse(order);

                              _this6.payment.deSelectGiftCards(); // Un-select any selected gift card if partial payment results


                              if (_this6.checkModel.containsSessionExpiredPaymentError) {
                                _this6.handleSessionExpiry();

                                _this6.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "Payment", {
                                  paymentCode: _this6.checkModel.paymentCode,
                                  restNum: (_this6$checkModel$ord2 = _this6.checkModel.order) === null || _this6$checkModel$ord2 === void 0 ? void 0 : _this6$checkModel$ord2.restNumber,
                                  success: false,
                                  message: "Mobile Pay Session Expired"
                                });

                                _this6.receivedError = true;

                                _this6.dispatchMobilePayError("Mobile Pay Session Expired");
                              } else {
                                _this6.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "Payment", {
                                  success: false,
                                  restNum: (_this6$checkModel$ord3 = _this6.checkModel.order) === null || _this6$checkModel$ord3 === void 0 ? void 0 : _this6$checkModel$ord3.restNumber,
                                  paymentType: _this6.payment.activeOtherOptionTab,
                                  total: _this6.payment.orderTotalIncludingGratuity,
                                  tip: _this6.payment.gratuity,
                                  base: _this6.payment.remainingOrderTotal,
                                  tax: _this6.payment.orderPriceInfo.tax,
                                  discount: _this6.payment.orderPriceInfo.discountAmount
                                });

                                _this6.receivedError = true;

                                _this6.dispatchMobilePayError("Payment Failure");

                                if (_this6.checkModel.generalPaymentFailure) {
                                  _this6.route = Route.PAYMENT_FAILURE;
                                }
                              }
                            }

                            runInAction(function () {
                              _this6.checkModel.paymentCode = "";
                            });
                            _context10.next = 74;
                            break;

                          case 70:
                            _this6.formState.isSubmitting = false;
                            _this6.formState.isFailed = true;

                            _this6.processTheProcessingError(processingError); // analytics submit order failed event


                            _this6.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "Payment", {
                              paymentCode: _this6.checkModel.paymentCode,
                              success: false,
                              restNum: (_this6$checkModel$ord4 = _this6.checkModel.order) === null || _this6$checkModel$ord4 === void 0 ? void 0 : _this6$checkModel$ord4.restNumber,
                              message: processingError
                            });

                          case 74:
                            _context10.next = 122;
                            break;

                          case 76:
                            _context10.prev = 76;
                            _context10.t0 = _context10["catch"](3);
                            _this6.receivedError = true;
                            loadCheckError = DPServices.Common.handleUIErrorAndOverride(_context10.t0, {
                              title: "",
                              message: ""
                            }); // updating value to null so can use "??"

                            loadCheckError.message = (_loadCheckError$messa2 = loadCheckError.message) !== null && _loadCheckError$messa2 !== void 0 && _loadCheckError$messa2.length ? loadCheckError.message : null;

                            if (!loadCheckError.errorCode) {
                              _context10.next = 115;
                              break;
                            }

                            analyticsError = {};
                            analyticsError.errorCode = loadCheckError.errorCode;
                            _context10.t1 = loadCheckError.errorCode;
                            _context10.next = _context10.t1 === MobilePayPaymentFailure["DRI-570"] ? 87 : _context10.t1 === MobilePayPaymentFailure.DRI_570 ? 87 : _context10.t1 === MobilePayPaymentFailure.ERROR_CHECK_OVER_PAID ? 87 : _context10.t1 === MobilePayPaymentFailure.ERROR_MERCHANT_ID_NOT_FOUND ? 90 : _context10.t1 === MobilePayPaymentFailure.paymentExceptions ? 90 : _context10.t1 === MobilePayPaymentFailure.ERROR_GENERIC_PAYMENT_FAILURE ? 90 : _context10.t1 === MobilePayPaymentFailure.dfpRejectType ? 93 : _context10.t1 === MobilePayPaymentFailure.fraudPaymentToken ? 93 : _context10.t1 === MobilePayPaymentFailure.ERROR_DFP_CHECK_LOCKED ? 93 : _context10.t1 === MobilePayPaymentFailure.bamsErrorResponse ? 93 : _context10.t1 === MobilePayPaymentFailure.ERROR_CHECK_NOT_FOUND ? 98 : _context10.t1 === MobilePayPaymentFailure.ERROR_CHECK_CLOSED ? 98 : _context10.t1 === MobilePayPaymentFailure.ERROR_CHECK_VERSION_MISMATCH ? 98 : _context10.t1 === MobilePayPaymentFailure.ERROR_CHECK_LOCKED ? 98 : _context10.t1 === MobilePayPaymentFailure.sessionExpired ? 101 : _context10.t1 === MobilePayPaymentFailure.CHECK_NOT_LOADED ? 101 : _context10.t1 === MobilePayPaymentFailure.ERROR_CHECK_NOT_LOADED ? 101 : _context10.t1 === MobilePayPaymentFailure.ERROR_CUSTOM_GRATUITY_THRESHOLD_EXCEEDS ? 104 : _context10.t1 === MobilePayPaymentFailure.SubmitOrderFail ? 107 : 110;
                            break;

                          case 87:
                            if (loadCheckError.errorCode === MobilePayPaymentFailure.ERROR_CHECK_OVER_PAID) {
                              _this6.checkModel.dialogueCode = DialogueCodes.ERROR_ERROR_CHECK_OVER_PAID;
                            } else {
                              _this6.checkModel.dialogueCode = DialogueCodes.ERROR_DRI_570;
                            }

                            _this6.route = Route.PAYMENT_FAILURE;
                            return _context10.abrupt("break", 112);

                          case 90:
                            if (loadCheckError.errorCode === MobilePayPaymentFailure.ERROR_GENERIC_PAYMENT_FAILURE) {
                              _this6.checkModel.dialogueCode = DialogueCodes.ERROR_GENERIC_PAYMENT_FAILURE;
                            } else if (loadCheckError.errorCode === MobilePayPaymentFailure.paymentExceptions) {
                              _this6.checkModel.dialogueCode = DialogueCodes.ERROR_PAYMENT_EXCEPTIONS;
                            } else {
                              _this6.checkModel.dialogueCode = DialogueCodes.ERROR_MERCHANT_ID_NOT_FOUND;
                            }

                            _this6.route = Route.PAYMENT_FAILURE;
                            return _context10.abrupt("break", 112);

                          case 93:
                            if (loadCheckError.errorCode === MobilePayPaymentFailure.dfpRejectType) {
                              _this6.checkModel.dialogueCode = DialogueCodes.PAYMENT_DFP_REJECT;
                            } else if (loadCheckError.errorCode === MobilePayPaymentFailure.ERROR_DFP_CHECK_LOCKED) {
                              _this6.checkModel.dialogueCode = DialogueCodes.ERROR_DFP_CHECK_LOCKED;
                            } else if (loadCheckError.errorCode === MobilePayPaymentFailure.bamsErrorResponse) {
                              _this6.checkModel.dialogueCode = DialogueCodes.ERROR_BAMS_ERROR_RESPONSE;
                            } else {
                              _this6.checkModel.dialogueCode = DialogueCodes.ERROR_FRAUD_PAYMENT_TOKEN;
                            }

                            _this6.appMessages.showError("Payment Error", "We're sorry, your payment method was not able to be processed. Please contact your server to settle your check.", null, null, null, null, _this6.checkModel.dialogueCode);

                            analyticsError.errorDescription = "We're sorry, your payment method was not able to be processed. Please contact your server to settle your check.";

                            if (loadCheckError.errorCode === MobilePayPaymentFailure.ERROR_DFP_CHECK_LOCKED && !_this6.checkModel.order.isCheckLockedForFraudSuspicion) {
                              _this6.loadCheck();
                            }

                            return _context10.abrupt("break", 112);

                          case 98:
                            if (loadCheckError.errorCode === MobilePayPaymentFailure.ERROR_CHECK_LOCKED) {
                              _this6.checkModel.dialogueCode = DialogueCodes.PAYMENT_CLOSED_CHECK;
                            } else if (loadCheckError.errorCode === MobilePayPaymentFailure.ERROR_CHECK_CLOSED) {
                              _this6.checkModel.dialogueCode = DialogueCodes.CHECK_CLOSED;
                            } else if (loadCheckError.errorCode === MobilePayPaymentFailure.ERROR_CHECK_NOT_FOUND) {
                              _this6.checkModel.dialogueCode = DialogueCodes.CHECK_NOT_FOUND;
                            } else {
                              _this6.checkModel.dialogueCode = DialogueCodes.ERROR_CHECK_VERSION_MISMATCH;
                            }

                            _this6.route = Route.CHECK_UPDATED;
                            return _context10.abrupt("break", 112);

                          case 101:
                            if (loadCheckError.errorCode === MobilePayPaymentFailure.sessionExpired) {
                              _this6.checkModel.dialogueCode = DialogueCodes.ERROR_SESSION_EXPIRY;
                            } else {
                              _this6.checkModel.dialogueCode = DialogueCodes.ERROR_CHECK_NOT_LOADED;
                            }

                            _this6.handleSessionExpiry();

                            return _context10.abrupt("break", 112);

                          case 104:
                            _this6.checkModel.dialogueCode = DialogueCodes.ERROR_CUSTOM_GRATUITY_THRESHOLD_EXCEEDS;

                            _this6.payment.gratuityModel.handleInvalidModel(_this6.appMessages);

                            return _context10.abrupt("break", 112);

                          case 107:
                            _this6.checkModel.dialogueCode = DialogueCodes.ERROR_SUBMIT_ORDER_FAIL;
                            _this6.route = Route.PAYMENT_FAILURE;
                            return _context10.abrupt("break", 112);

                          case 110:
                            _this6.checkModel.dialogueCode = DialogueCodes.ERROR_FAULTS_NOT_HANDLED;

                            _this6.appMessages.showError((_loadCheckError$title = loadCheckError.title) !== null && _loadCheckError$title !== void 0 ? _loadCheckError$title : "Failed", loadCheckError.message, null, null, null, null, _this6.checkModel.dialogueCode);

                          case 112:
                            _this6.dispatchMobilePayError(analyticsError.errorCode, analyticsError.errorDescription);

                            _context10.next = 118;
                            break;

                          case 115:
                            _this6.checkModel.dialogueCode = DialogueCodes.ERROR_CASE_MISSING;
                            _this6.route = Route.PAYMENT_FAILURE;

                            _this6.dispatchMobilePayError("Payment Failure");

                          case 118:
                            _this6.formState.isSubmitting = false;
                            _this6.formState.isFailed = true;

                            _this6.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "Payment", {
                              paymentCode: _this6.checkModel.paymentCode,
                              success: false,
                              restNum: (_this6$checkModel$ord5 = _this6.checkModel.order) === null || _this6$checkModel$ord5 === void 0 ? void 0 : _this6$checkModel$ord5.restNumber,
                              message: loadCheckError.errorCode
                            });

                            resolve({
                              status: "ERROR"
                            });

                          case 122:
                            _context10.next = 128;
                            break;

                          case 124:
                            _this6.formState.isSubmitting = false;

                            _this6.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "Payment", {
                              paymentCode: _this6.checkModel.paymentCode,
                              success: false,
                              restNum: (_this6$checkModel$ord6 = _this6.checkModel.order) === null || _this6$checkModel$ord6 === void 0 ? void 0 : _this6$checkModel$ord6.restNumber,
                              message: "Payment Failure"
                            });

                            _this6.receivedError = true;

                            _this6.dispatchMobilePayError("Payment Failure");

                          case 128:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee10, null, [[3, 76]]);
                  })));
                }));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function payCheck() {
        return _payCheck.apply(this, arguments);
      }

      return payCheck;
    }()
  }, {
    key: "handleSessionExpiry",
    value: function handleSessionExpiry() {
      var _this7 = this,
          _this$checkModel$orde8;

      this.appMessages.showError("Session Expired", "Your session has expired due to an extended period of inactivity.", null, {
        undismissible: true,
        okBtnText: "Refresh",
        okBtnOnClick: function okBtnOnClick() {
          if (_this7.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
            _this7.loadCheck();
          } else {
            _this7.rootStore.platformUtil.refreshPage();
          }
        }
      }, null, null, this.checkModel.dialogueCode);
      this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "MobilePay", {
        paymentCode: this.checkModel.paymentCode,
        success: false,
        restNum: (_this$checkModel$orde8 = this.checkModel.order) === null || _this$checkModel$orde8 === void 0 ? void 0 : _this$checkModel$orde8.restNumber,
        message: "Session Expired"
      });
      this.receivedError = true;
      this.dispatchMobilePayError("MobilePay Session Expired");
    }
  }, {
    key: "sendEmailReceiptRequest",
    value: function () {
      var _sendEmailReceiptRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var paymentCode, email, _this$checkModel$orde9, _this$checkModel$orde10;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                paymentCode = this.checkModel.paymentCode;
                email = this.emailReceiptModel.emailId;
                _context12.prev = 2;
                _context12.next = 5;
                return DPServices.Check.sendEmailConfirmation(email, paymentCode);

              case 5:
                // this.checkModel.dialogueCode = DialogueCodes.SEND_MAIL_RECEIPT_SUCCESS;
                // this.appMessages.showSuccess(
                //   "Receipt",
                //   "Email receipt sent.",
                //   null,
                //   null,
                //   this.checkModel.dialogueCode,
                // );
                this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "MobilePay", {
                  paymentCode: this.checkModel.paymentCode,
                  success: true,
                  restNum: (_this$checkModel$orde9 = this.checkModel.order) === null || _this$checkModel$orde9 === void 0 ? void 0 : _this$checkModel$orde9.restNumber,
                  message: "Email receipt sent."
                });
                _context12.next = 13;
                break;

              case 8:
                _context12.prev = 8;
                _context12.t0 = _context12["catch"](2); // this.checkModel.dialogueCode =
                //   DialogueCodes.ERROR_SEND_MAIL_RECEIPT_FAILED;
                // this.appMessages.showError(
                //   "Failed",
                //   "Failed to send receipt.",
                //   null,
                //   null,
                //   null,
                //   null,
                //   this.checkModel.dialogueCode,
                // );

                this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "MobilePay", {
                  paymentCode: this.checkModel.paymentCode,
                  success: false,
                  restNum: (_this$checkModel$orde10 = this.checkModel.order) === null || _this$checkModel$orde10 === void 0 ? void 0 : _this$checkModel$orde10.restNumber,
                  message: "Failed to send email receipt."
                });
                this.receivedError = true;
                this.dispatchMobilePayError("".concat(_context12.t0), "Failed to send email receipt.");

              case 13:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[2, 8]]);
      }));

      function sendEmailReceiptRequest() {
        return _sendEmailReceiptRequest.apply(this, arguments);
      }

      return sendEmailReceiptRequest;
    }()
  }, {
    key: "determinePaymentMethods",
    value: function determinePaymentMethods(order) {
      var _this$mobilePayAppAtt,
          _this$mobilePayAppAtt2,
          _this$mobilePayAppAtt3,
          _this$mobilePayAppAtt4,
          _order$order5,
          _order$order5$subTota,
          _this8 = this;

      var _getEnvProps = getEnvProps(),
          NODE_ENV = _getEnvProps.NODE_ENV;

      var DEV_NODE_ENV = NODE_ENV === "development";
      var isApplePayEnabled = DEV_NODE_ENV ? true : (_this$mobilePayAppAtt = (_this$mobilePayAppAtt2 = this.mobilePayAppAttributes) === null || _this$mobilePayAppAtt2 === void 0 ? void 0 : _this$mobilePayAppAtt2.applePayEnabled) !== null && _this$mobilePayAppAtt !== void 0 ? _this$mobilePayAppAtt : true;
      var isGooglePayEnabled = DEV_NODE_ENV ? true : (_this$mobilePayAppAtt3 = (_this$mobilePayAppAtt4 = this.mobilePayAppAttributes) === null || _this$mobilePayAppAtt4 === void 0 ? void 0 : _this$mobilePayAppAtt4.googlePayEnabled) !== null && _this$mobilePayAppAtt3 !== void 0 ? _this$mobilePayAppAtt3 : true;
      this.payment.subTotalWithoutItemDiscount = order === null || order === void 0 ? void 0 : (_order$order5 = order.order) === null || _order$order5 === void 0 ? void 0 : (_order$order5$subTota = _order$order5.subTotal) === null || _order$order5$subTota === void 0 ? void 0 : _order$order5$subTota.value;

      if (isApplePayEnabled && isGooglePayEnabled) {
        // Only Google Play
        this.rootStore.refreshInProgress = true;
        Promise.all([this.rootStore.platformUtil.canMakeApplePayPayment(this.payment.applePayPaymentMerchantId), this.rootStore.platformUtil.canMakeGooglePayPayment(this.payment.googlePayIsReadyToPayRequest)]).then(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              canUseApplePay = _ref3[0],
              canUseGooglePay = _ref3[1];

          _this8.rootStore.refreshInProgress = false;
          _this8.payment.isGooglePayEnabled = canUseGooglePay;
          _this8.payment.isApplePayEnabled = canUseApplePay;

          if (canUseApplePay) {
            _this8.payment.activeOtherOptionTab = OnlinePaymentTypes.APPLE_PAY;
          } else {
            if (canUseGooglePay) {
              _this8.payment.activeOtherOptionTab = OnlinePaymentTypes.GOOGLE_PAY;
            } else {
              _this8.payment.activeOtherOptionTab = OnlinePaymentTypes.NONE;
            }
          }
        });
      } else {
        if (isApplePayEnabled) {
          // Only Google Play
          this.rootStore.refreshInProgress = true;
          Promise.all([this.rootStore.platformUtil.canMakeApplePayPayment(this.payment.applePayPaymentMerchantId)]).then(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 1),
                canUseApplePay = _ref5[0];

            _this8.rootStore.refreshInProgress = false;
            _this8.payment.isGooglePayEnabled = false;
            _this8.payment.isApplePayEnabled = canUseApplePay;

            if (canUseApplePay) {
              _this8.payment.activeOtherOptionTab = OnlinePaymentTypes.APPLE_PAY;
            } else {
              _this8.payment.activeOtherOptionTab = OnlinePaymentTypes.NONE;
            }
          });
        } else {
          if (isGooglePayEnabled) {
            // Only Google Play
            this.rootStore.refreshInProgress = true;
            Promise.all([this.rootStore.platformUtil.canMakeGooglePayPayment(this.payment.googlePayIsReadyToPayRequest)]).then(function (_ref6) {
              var _ref7 = _slicedToArray(_ref6, 1),
                  canUseGooglePay = _ref7[0];

              _this8.rootStore.refreshInProgress = false;
              _this8.payment.isApplePayEnabled = false;
              _this8.payment.isGooglePayEnabled = canUseGooglePay;
              _this8.payment.activeOtherOptionTab = OnlinePaymentTypes.GOOGLE_PAY;
              _this8.payment.activeOtherOptionTab = canUseGooglePay ? OnlinePaymentTypes.GOOGLE_PAY : OnlinePaymentTypes.NONE;
            });
          } else {
            //Neither
            this.payment.isApplePayEnabled = false;
            this.payment.isGooglePayEnabled = false;

            if (this.payment.activeOtherOptionTab === OnlinePaymentTypes.NONE || this.payment.activeOtherOptionTab === OnlinePaymentTypes.GOOGLE_PAY || this.payment.activeOtherOptionTab === OnlinePaymentTypes.APPLE_PAY) {
              this.payment.activeOtherOptionTab = OnlinePaymentTypes.NONE;
            }
          }
        }
      }
    }
  }, {
    key: "decodeAuthError",
    value: function decodeAuthError(reason) {
      if (reason) {
        if (reason === "REQUEST_TIMEOUT") {
          return "Your payment request has been timed out. Please try again.";
        } else {
          return reason;
        }
      } else {
        return reason;
      }
    }
  }, {
    key: "onGooglePayAuthorized",
    value: function () {
      var _onGooglePayAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(payment) {
        var result, success, faultCode;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this.payment.googlePayAuthorization = payment;

                if (!payment) {
                  _context13.next = 21;
                  break;
                }

                _context13.next = 4;
                return this.payCheck();

              case 4:
                result = _context13.sent;
                success = result.status === "SUCCESS";

                if (success) {
                  _context13.next = 18;
                  break;
                }

                this.payment.googlePayAuthorization = null;
                faultCode = result.faultCode;

                if (!(faultCode && faultCode.indexOf("PaymentService") === 0)) {
                  _context13.next = 15;
                  break;
                }

                this.receivedError = true;
                this.dispatchMobilePayError(faultCode, this.decodeAuthError(result.reason) || "Failed to place order.");
                return _context13.abrupt("return", {
                  error: {
                    reason: "OTHER_ERROR",
                    message: this.decodeAuthError(result.reason) || "Failed to place order.",
                    intent: "PAYMENT_AUTHORIZATION"
                  },
                  transactionState: "ERROR"
                });

              case 15:
                return _context13.abrupt("return", {
                  transactionState: "SUCCESS"
                });

              case 16:
                _context13.next = 19;
                break;

              case 18:
                return _context13.abrupt("return", {
                  transactionState: "SUCCESS"
                });

              case 19:
                _context13.next = 26;
                break;

              case 21:
                this.checkModel.dialogueCode = DialogueCodes.GOOGLE_PAY_AUTHORIZATION_FAILED;
                this.appMessages.showError("Google Pay", "Google Pay authorization failed. Please try again.", null, null, null, null, this.checkModel.dialogueCode);
                this.receivedError = true;
                this.dispatchMobilePayError("Google Pay", "Google Pay authorization failed. Please try again.");
                return _context13.abrupt("return", {
                  transactionState: "ERROR"
                });

              case 26:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function onGooglePayAuthorized(_x4) {
        return _onGooglePayAuthorized.apply(this, arguments);
      }

      return onGooglePayAuthorized;
    }()
  }, {
    key: "googlePayCancel",
    value: function () {
      var _googlePayCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(reason) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                console.log(reason);
                this.checkModel.dialogueCode = DialogueCodes.GOOGLE_PAY_PAYMENT_CANCELLED;
                this.appMessages.showError("Google Pay", "Google Pay cancelled. Please try again.", null, null, null, null, this.checkModel.dialogueCode);
                this.receivedError = true;
                this.dispatchMobilePayError(JSON.stringify(reason));

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function googlePayCancel(_x5) {
        return _googlePayCancel.apply(this, arguments);
      }

      return googlePayCancel;
    }()
  }, {
    key: "googlePayErrored",
    value: function () {
      var _googlePayErrored = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(errData) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                this.payment.googlePayErrored = true;
                Logger.log(errData);
                this.receivedError = true;
                this.dispatchMobilePayError("GOOGLE_PAY_ERRORED", JSON.stringify(errData));

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function googlePayErrored(_x6) {
        return _googlePayErrored.apply(this, arguments);
      }

      return googlePayErrored;
    }()
  }, {
    key: "onApplePayAuthorized",
    value: function () {
      var _onApplePayAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(event) {
        var payment, result, success, faultCode, message;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                payment = event.payment;
                this.payment.applePayAuthorization = payment;

                if (!payment) {
                  _context16.next = 11;
                  break;
                }

                _context16.next = 5;
                return this.payCheck();

              case 5:
                result = _context16.sent;
                success = result.status === "SUCCESS";

                if (!success) {
                  this.payment.applePayAuthorization = null;
                  faultCode = result.faultCode;

                  if (faultCode && faultCode.indexOf("PaymentService") === 0) {
                    message = this.decodeAuthError(result.reason);
                    this.appMessages.showError("Apple Pay", message, null, null, null, null, this.checkModel.dialogueCode);
                  }
                }

                return _context16.abrupt("return", success);

              case 11:
                this.checkModel.dialogueCode = DialogueCodes.APPLE_PAY_AUTHORIZATION_FAILED;
                this.appMessages.showError("Apple Pay", "Apple Pay authorization failed. Please try again.", null, null, null, null, this.checkModel.dialogueCode);
                this.receivedError = true;
                this.dispatchMobilePayError("Apple Pay", "Apple Pay authorization failed. Please try again.");
                return _context16.abrupt("return", false);

              case 16:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function onApplePayAuthorized(_x7) {
        return _onApplePayAuthorized.apply(this, arguments);
      }

      return onApplePayAuthorized;
    }()
  }, {
    key: "applePayCancel",
    value: function () {
      var _applePayCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                this.checkModel.dialogueCode = DialogueCodes.APPLE_PAY_PAYMENT_CANCELLED;
                this.appMessages.showError("Apple Pay", "Apple Pay cancelled. Please try again.", null, null, null, null, this.checkModel.dialogueCode);
                this.receivedError = true;
                this.dispatchMobilePayError("Apple Pay cancelled. Please try again.");

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function applePayCancel() {
        return _applePayCancel.apply(this, arguments);
      }

      return applePayCancel;
    }()
  }, {
    key: "applePayErrored",
    value: function () {
      var _applePayErrored = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(errData) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                this.payment.applePayErrored = true;
                Logger.log(errData);
                this.receivedError = true;
                this.dispatchMobilePayError("APPLE_PAY_ERRORED", JSON.stringify(errData));

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function applePayErrored(_x8) {
        return _applePayErrored.apply(this, arguments);
      }

      return applePayErrored;
    }()
  }, {
    key: "getDefaultTipPercentage",
    value: function () {
      var _getDefaultTipPercentage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var _this$appAttributes$c, _this$appAttributes$c2, _this$mobilePayAppAtt5, isFlowOPCIO, configs, JWT_TOKEN, appInitData, errorUI;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                isFlowOPCIO = this.payment.flow === PaymentFlow.MPAY_OPCIO;

                if (this.payment) {
                  configs = this.appAttributes.configs;

                  if (isFlowOPCIO) {
                    // Configure To-Go slider for CIPAY
                    this.payment.gratuityModel.minTipPercentage = parseInt(configs.min_tip_percentage) || 0;
                    this.payment.gratuityModel.maxTipPercentage = parseInt(configs.max_tip_percentage) || 100;
                    this.payment.gratuityModel.tipLabelStep = parseInt(configs.max_tip_label_step) || 10;
                  } else {
                    // Dine-in Mobile Pat slider
                    this.payment.gratuityModel.minTipPercentage = parseInt(configs.mobile_pay_min_tip_percentage) || 0;
                    this.payment.gratuityModel.maxTipPercentage = parseInt(configs.mobile_pay_max_tip_percentage) || 100;
                    this.payment.gratuityModel.tipLabelStep = parseInt(configs.mobile_pay_tip_label_step) || 10;
                  }
                }

                _context19.next = 5;
                return this.rootStore.user.getTokenSilentIfLoggedIn();

              case 5:
                JWT_TOKEN = _context19.sent;
                _context19.next = 8;
                return DPServices.Check.getMobilePayAppInitData(JWT_TOKEN);

              case 8:
                appInitData = _context19.sent;
                this.mobilePayAppAttributes = appInitData;
                this.payment.gratuityModel.selectedTipPercentage = Number(isFlowOPCIO ? ((_this$appAttributes$c = this.appAttributes.configs) === null || _this$appAttributes$c === void 0 ? void 0 : _this$appAttributes$c.defaultTipPercentage) || 15 : ((_this$appAttributes$c2 = this.appAttributes.configs) === null || _this$appAttributes$c2 === void 0 ? void 0 : _this$appAttributes$c2.defaultMobilePayTipPercentage) || 20);
                this.payment.savedGiftCardsLimit = (_this$mobilePayAppAtt5 = this.mobilePayAppAttributes) === null || _this$mobilePayAppAtt5 === void 0 ? void 0 : _this$mobilePayAppAtt5.savedGiftCardMaxLimit;
                _context19.next = 20;
                break;

              case 14:
                _context19.prev = 14;
                _context19.t0 = _context19["catch"](0);
                errorUI = DPServices.Common.handleUIErrorAndOverride(_context19.t0, {
                  title: ERROR_STRINGS.UNEXPECTED_ERROR,
                  message: Errors.MOBILE_PAY_APP_INIT_FAILED.message
                });
                this.rootStore.platformUtil.redirectToURL("/");
                this.receivedError = true;
                this.dispatchMobilePayError(errorUI.message);

              case 20:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[0, 14]]);
      }));

      function getDefaultTipPercentage() {
        return _getDefaultTipPercentage.apply(this, arguments);
      }

      return getDefaultTipPercentage;
    }()
  }, {
    key: "checkForSavedSettlementInformation",
    value: function checkForSavedSettlementInformation(paymentItems) {
      if (!!paymentItems) {
        var _paymentItems$payment;

        var index = paymentItems === null || paymentItems === void 0 ? void 0 : (_paymentItems$payment = paymentItems.paymentItem) === null || _paymentItems$payment === void 0 ? void 0 : _paymentItems$payment.findIndex(function (payment) {
          var _payment$settlementIn;

          return (payment === null || payment === void 0 ? void 0 : (_payment$settlementIn = payment.settlementInformation) === null || _payment$settlementIn === void 0 ? void 0 : _payment$settlementIn.status) === "SAVED";
        });
        return index === -1 ? false : true;
      }

      return false;
    }
  }, {
    key: "loadCheckForShortToken",
    value: function () {
      var _loadCheckForShortToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(shortToken) {
        var _this9 = this;

        var _yield$handle9, _yield$handle10, checkError, checkSummary, _checkSummary$orderSu, token, _this$rootStore3;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this.route = Route.DIGITAL_CHECK_LOADING;

                if (!shortToken) {
                  _context20.next = 11;
                  break;
                }

                _context20.next = 4;
                return handle(DPServices.Curbside.getCheckSummary(shortToken));

              case 4:
                _yield$handle9 = _context20.sent;
                _yield$handle10 = _slicedToArray(_yield$handle9, 2);
                checkError = _yield$handle10[0];
                checkSummary = _yield$handle10[1];

                if (checkError) {
                  this.checkModel.dialogueCode = DialogueCodes.ERROR_SHORT_TOKEN_SUMMARY;
                  this.appMessages.showError("Something went wrong", "", null, {
                    undismissible: true,
                    okBtnText: "Ok",
                    okBtnOnClick: function okBtnOnClick() {
                      return _this9._redirectToHome();
                    }
                  }, null, null, this.checkModel.dialogueCode);
                  this.receivedError = true;
                  this.dispatchMobilePayError(checkError.message);
                } else {
                  token = checkSummary === null || checkSummary === void 0 ? void 0 : (_checkSummary$orderSu = checkSummary.orderSummary) === null || _checkSummary$orderSu === void 0 ? void 0 : _checkSummary$orderSu.tokenID;

                  if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
                    this.rootStore.mobilePay.checkModel.paymentCode = token;
                    this.loadCheck().then(function () {
                      _this9.dispatchMobilePayScan("link");
                    });
                  } else {
                    (_this$rootStore3 = this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : _this$rootStore3.platformUtil.redirectToURL("/pay?paymentCode=".concat(token));
                  }
                }

                _context20.next = 13;
                break;

              case 11:
                this.checkModel.dialogueCode = DialogueCodes.ERROR_SHORT_TOKEN_MISSING;
                this.appMessages.showError("Something went wrong", "", null, {
                  undismissible: true,
                  okBtnText: "Ok",
                  okBtnOnClick: function okBtnOnClick() {
                    return _this9._redirectToHome();
                  }
                }, null, null, this.checkModel.dialogueCode);

              case 13:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function loadCheckForShortToken(_x9) {
        return _loadCheckForShortToken.apply(this, arguments);
      }

      return loadCheckForShortToken;
    }()
  }, {
    key: "_redirectToHome",
    value: function _redirectToHome() {
      if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
        var _this$rootStore4;

        (_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : _this$rootStore4.platformUtil.redirectToURL("/home");
      } else {
        this.rootStore.platformUtil.navigateToRoute("/home");
      }
    }
  }, {
    key: "dispatchMobilePayScan",
    value: function dispatchMobilePayScan(scanType) {
      var _this$checkModel$orde11;

      var restNum = this.getRestNumFromOrderOrPaymentCode();
      this.analyticsModel.dispatchMobilePayScan({
        mobilePayType: this.payment.flow,
        paymentCode: this.checkModel.paymentCode,
        restNum: restNum,
        scanType: scanType,
        CLQEnabled: "true",
        OPCIOEnabled: "true",
        TLQEnabled: (_this$checkModel$orde11 = this.checkModel.order.mobilePayEnable) !== null && _this$checkModel$orde11 !== void 0 && _this$checkModel$orde11.tableMobilePayEnable ? "true" : "false"
      });
    }
  }, {
    key: "dispatchMobilePayComplete",
    value: function dispatchMobilePayComplete() {
      var _checkModel$order, _this$checkModel$orde12, _checkModel$order2, _checkModel$order2$ch, _checkModel$order3, _this$payment$orderPr3, _this$checkModel$orde13;

      var checkModel = this.checkModel;
      var paymentMethod = null;
      (_checkModel$order = checkModel.order) === null || _checkModel$order === void 0 ? void 0 : _checkModel$order.order.paymentItems.paymentItem.forEach(function (paymentItem) {
        if (paymentMethod !== MPAnalyticsPaymentMethod.GIFT) {
          paymentMethod = MPAnalyticsPaymentMethod[paymentItem.paymentClassification];
        }
      });
      var payload = {
        mobilePayType: this.payment.flow,
        paymentMethod: paymentMethod,
        restNum: (_this$checkModel$orde12 = this.checkModel.order) === null || _this$checkModel$orde12 === void 0 ? void 0 : _this$checkModel$orde12.restNumber,
        checkNumber: (_checkModel$order2 = checkModel.order) === null || _checkModel$order2 === void 0 ? void 0 : (_checkModel$order2$ch = _checkModel$order2.checkNumber) === null || _checkModel$order2$ch === void 0 ? void 0 : _checkModel$order2$ch.toString(),
        receivedError: this.receivedError ? "true" : "false",
        paymentCode: (_checkModel$order3 = checkModel.order) === null || _checkModel$order3 === void 0 ? void 0 : _checkModel$order3.paymentCode,
        discount: this.payment.orderPriceInfo.discountAmount.toString(),
        tipPercentage: (_this$payment$orderPr3 = this.payment.orderPriceInfo.gratuityAlreadyPaid) === null || _this$payment$orderPr3 === void 0 ? void 0 : _this$payment$orderPr3.toString(),
        tax: this.payment.orderPriceInfo.tax.toString(),
        total: (this.payment.orderTotal + this.payment.orderPriceInfo.gratuityAlreadyPaid).toString(),
        CLQEnabled: "true",
        OPCIOEnabled: "true",
        TLQEnabled: (_this$checkModel$orde13 = this.checkModel.order.mobilePayEnable) !== null && _this$checkModel$orde13 !== void 0 && _this$checkModel$orde13.tableMobilePayEnable ? "true" : "false"
      };
      this.analyticsModel.dispatchMobilePayComplete(payload);
    }
  }, {
    key: "dispatchMobilePayError",
    value: function dispatchMobilePayError(errorCode) {
      var _checkModel$order4, _checkModel$order7;

      var errorDescription = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var checkModel = this.checkModel;
      var errorString = errorCode + (!!errorDescription ? ": " : "") + errorDescription;
      var payload = {};

      if ((_checkModel$order4 = checkModel.order) !== null && _checkModel$order4 !== void 0 && _checkModel$order4.checkNumber) {
        var _checkModel$order5;

        payload["checkNumber"] = (_checkModel$order5 = checkModel.order) === null || _checkModel$order5 === void 0 ? void 0 : _checkModel$order5.checkNumber;
      } else {
        var _checkModel$order6, _checkModel$order6$or, _checkModel$order6$or2;

        payload["orderId"] = (_checkModel$order6 = checkModel.order) === null || _checkModel$order6 === void 0 ? void 0 : (_checkModel$order6$or = _checkModel$order6.order.orderIDs) === null || _checkModel$order6$or === void 0 ? void 0 : (_checkModel$order6$or2 = _checkModel$order6$or.orderID[1]) === null || _checkModel$order6$or2 === void 0 ? void 0 : _checkModel$order6$or2.ID;
      }

      var dialogueCode = getDialogueCode({
        errorCodeToAppend: this.checkModel.dialogueCode,
        isPlatformMobileApp: this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP,
        paymentFlow: this.payment.flow
      });
      var restNum = this.getRestNumFromOrderOrPaymentCode();
      this.analyticsModel.dispatchMobilePayError(_objectSpread(_objectSpread({}, payload), {}, {
        errorCode: errorString,
        mobilePayType: this.payment.flow,
        paymentCode: (_checkModel$order7 = checkModel.order) === null || _checkModel$order7 === void 0 ? void 0 : _checkModel$order7.paymentCode,
        dialogCode: dialogueCode,
        restNum: restNum
      }));
    }
  }, {
    key: "dispatchMobilePayCTAClick",
    value: function dispatchMobilePayCTAClick(CTAName) {
      var _checkModel$order8, _checkModel$order11, _this$checkModel$orde14;

      var checkModel = this.checkModel;
      var payload = {};

      if ((_checkModel$order8 = checkModel.order) !== null && _checkModel$order8 !== void 0 && _checkModel$order8.checkNumber) {
        var _checkModel$order9;

        payload["checkNumber"] = (_checkModel$order9 = checkModel.order) === null || _checkModel$order9 === void 0 ? void 0 : _checkModel$order9.checkNumber;
      } else {
        var _checkModel$order10, _checkModel$order10$o, _checkModel$order10$o2;

        payload["orderId"] = (_checkModel$order10 = checkModel.order) === null || _checkModel$order10 === void 0 ? void 0 : (_checkModel$order10$o = _checkModel$order10.order.orderIDs) === null || _checkModel$order10$o === void 0 ? void 0 : (_checkModel$order10$o2 = _checkModel$order10$o.orderID[1]) === null || _checkModel$order10$o2 === void 0 ? void 0 : _checkModel$order10$o2.ID;
      }

      this.analyticsModel.dispatchMobilePayCTAClick(_objectSpread(_objectSpread({}, payload), {}, {
        CTAName: CTAName,
        mobilePayType: this.payment.flow,
        paymentCode: (_checkModel$order11 = checkModel.order) === null || _checkModel$order11 === void 0 ? void 0 : _checkModel$order11.paymentCode,
        restNum: (_this$checkModel$orde14 = this.checkModel.order) === null || _this$checkModel$orde14 === void 0 ? void 0 : _this$checkModel$orde14.restNumber.toString()
      }));
    }
  }, {
    key: "getRestNumFromOrderOrPaymentCode",
    value: function getRestNumFromOrderOrPaymentCode() {
      var _this$checkModel$orde15;

      var restNum = null;

      if (!!((_this$checkModel$orde15 = this.checkModel.order) !== null && _this$checkModel$orde15 !== void 0 && _this$checkModel$orde15.restNumber)) {
        restNum = this.checkModel.order.restNumber.toString();
      } else if (this.payment.flow === PaymentFlow.MPAY_TLQ) {
        restNum = this.checkModel.paymentCode.slice(0, 4);
      }

      return restNum;
    }
  }, {
    key: "couponCodeWidgetEnabled",
    get: function get() {
      return this._couponCodeWidgetEnabled;
    },
    set: function set(val) {
      var _this10 = this;

      runInAction(function () {
        _this10._couponCodeWidgetEnabled = val;
      });
    }
  }, {
    key: "canLoadCheck",
    get: function get() {
      var isMobilePayLoginEnforced = this.rootStore.common.mobilePayLoginEnforced;
      var isMobilePayAvailable = this.rootStore.user.isMobilePayAvailable;
      var paymentCode = this.checkModel.paymentCode;
      var paymentCodeValid = this.checkModel.isValid;
      return paymentCode && paymentCodeValid && (isMobilePayLoginEnforced && isMobilePayAvailable || !isMobilePayLoginEnforced);
    }
  }, {
    key: "isValid",
    get: function get() {
      var payment = this.payment,
          emailReceiptModel = this.emailReceiptModel;
      var gratuityModel = this.payment.gratuityModel;
      return payment.isValid && emailReceiptModel.isValid && gratuityModel.isValid;
    }
  }, {
    key: "route",
    set: function set(val) {
      var _this11 = this;

      runInAction(function () {
        _this11._route = val;
      });
    },
    get: function get() {
      return this._route;
    }
  }, {
    key: "shownInitialCheckForMPAY",
    get: function get() {
      return this._shownInitialCheckForMPAY;
    },
    set: function set(_shownInitialCheckForMPAY) {
      var _this12 = this;

      runInAction(function () {
        _this12._shownInitialCheckForMPAY = _shownInitialCheckForMPAY;
      });
    }
  }, {
    key: "restaurantPhoneNumber",
    get: function get() {
      var _this$restaurantDetai, _this$restaurantDetai2, _this$restaurantDetai3;

      var phone = (_this$restaurantDetai = this.restaurantDetails) === null || _this$restaurantDetai === void 0 ? void 0 : (_this$restaurantDetai2 = _this$restaurantDetai.contactDetail) === null || _this$restaurantDetai2 === void 0 ? void 0 : (_this$restaurantDetai3 = _this$restaurantDetai2.phoneDetail) === null || _this$restaurantDetai3 === void 0 ? void 0 : _this$restaurantDetai3.find(function (p) {
        return p.type === "Primary";
      });
      return formatPhoneNumber(phone === null || phone === void 0 ? void 0 : phone.phoneNumber);
    }
  }, {
    key: "showExitMobilePayDialogue",
    get: function get() {
      return this._showExitMobilePayDialogue;
    },
    set: function set(_showExitMobilePayDialogue) {
      var _this13 = this;

      runInAction(function () {
        _this13._showExitMobilePayDialogue = _showExitMobilePayDialogue;
      });
    }
  }]);

  return MobilePay;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "formState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_couponCodeWidgetEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_route", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return Route.CODE;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "mobilePayAppAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "restaurantDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_shownInitialCheckForMPAY", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_showExitMobilePayDialogue", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "couponCodeWidgetEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "couponCodeWidgetEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canLoadCheck", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canLoadCheck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "route", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "route"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantPhoneNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantPhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showExitMobilePayDialogue", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showExitMobilePayDialogue"), _class.prototype)), _class);
export { MobilePay as default };